<template>
  <div class="change">
    <el-divider content-position="left">工商变更进度</el-divider>
    <el-row>
      <el-select
        v-model="searchArr.company_id"
        filterable
        remote
        reserve-keyword
        placeholder="请输入公司名称筛选公司"
        size="mini"
        clearable
        :remote-method="searchRemoteCompanyMethod"
        :loading="searchLoading"
        @change="handleSearchCompanyChange"
      >
        <el-option
          v-for="searchCompany in searchCompanies"
          :key="searchCompany.id"
          :label="searchCompany.company_name"
          :value="searchCompany.id"
        >
        </el-option>
      </el-select>
      <el-select
        v-model="searchArr.id"
        filterable
        remote
        clearable
        reserve-keyword
        placeholder="请输入订单编号"
        size="mini"
        @change="handleOrderChange"
        :remote-method="remoteMethod"
        :loading="loading"
      >
        <el-option
          v-for="item in orderNums"
          :key="item.id"
          :label="item.order_num"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <el-select
        collapse-tags
        v-model="searchArr.status"
        placeholder="请选择办理完成状态"
        @change="handleOrderChange"
        size="mini"
        clearable
      >
        <el-option :value="1" label="未办理"></el-option>
        <el-option :value="2" label="办理中"></el-option>
        <el-option :value="3" label="已完成"></el-option>
      </el-select>
      <el-popover placement="bottom-start" v-model="searchVisible" width="320">
        <el-row style="margin-bottom: 0.4rem; padding-top: 0.5rem">
          <el-col :span="6" style="margin-top: 0.1rem">服务状态：</el-col>
          <el-col :span="18">
            <el-select
              v-model="searchArr.service_status"
              placeholder="请选择"
              size="mini"
              clearable
            >
              <el-option :value="3" label="服务中"></el-option>
              <el-option :value="4" label="服务完成"></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row style="margin-bottom: 0.4rem">
          <el-col :span="6" style="margin-top: 0.1rem">沟通顾问：</el-col>
          <el-col :span="18">
            <el-cascader
              style="width: 72%"
              v-model="searchArr.consultant"
              placeholder="请选择沟通顾问"
              :options="users"
              size="mini"
              :props="{ expandTrigger: 'hover' }"
              clearable
              filterable
              :filter-method="filterOptions"
            >
            </el-cascader>
          </el-col>
        </el-row>
        <el-row style="margin-bottom: 0.4rem">
          <el-col :span="6" style="margin-top: 0.1rem">行业特点：</el-col>
          <el-col :span="18">
            <el-select
              v-model="searchArr.feature"
              filterable
              placeholder="请选择"
              size="mini"
              clearable
            >
              <el-option
                v-for="item in features"
                :key="item.industry_id"
                :label="item.industry_name"
                :value="item.industry_id"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row style="margin-bottom: 0.4rem">
          <el-col :span="6" style="margin-top: 0.1rem">注册类型：</el-col>
          <el-col :span="18">
            <el-select
              v-model="searchArr.actual_reg_type"
              filterable
              placeholder="请选择"
              size="mini"
              clearable
            >
              <el-option
                v-for="item in regTypes"
                :key="item.reg_type_id"
                :label="item.reg_type_name"
                :value="item.reg_type_id"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row style="margin-bottom: 0.4rem">
          <el-col :span="6" style="margin-top: 0.1rem">服务人员：</el-col>
          <el-col :span="18">
            <el-cascader
              style="width: 72%"
              v-model="searchArr.operator"
              placeholder="请选择服务人员"
              :options="usersConvert"
              size="mini"
              :props="{ expandTrigger: 'hover' }"
              clearable
              filterable
              :filter-method="filterOptions"
            >
            </el-cascader>
          </el-col>
        </el-row>
        <el-row style="margin-bottom: 0.4rem">
          <el-col :span="6" style="margin-top: 0.1rem">订单平台：</el-col>
          <el-col :span="18">
            <el-select
              v-model="searchArr.platform"
              filterable
              placeholder="请选择"
              clearable
              size="mini"
            >
              <el-option :value="1" label="天眼查"></el-option>
              <el-option :value="2" label="云上飕飕"></el-option>
              <el-option :value="3" label="优开企业火"></el-option>
              <el-option :value="4" label="腾讯云"></el-option>
              <el-option :value="5" label="阿里云"></el-option>
              <el-option :value="6" label="顶呱呱"></el-option>
              <el-option :value="7" label="本公司订单"></el-option>
              <el-option :value="8" label="融易算"></el-option>
              <el-option :value="9" label="华为云"></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row style="margin-bottom: 0.4rem">
          <el-col :span="6" style="margin-top: 0.1rem">公司园区：</el-col>
          <el-col :span="18">
            <el-select
              v-model="searchArr.park"
              filterable
              placeholder="请选择"
              clearable
              size="mini"
            >
              <el-option
                v-for="option in parks"
                :key="option.id"
                :label="option.areaName"
                :value="option.id"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row style="margin-bottom: 0.4rem; margin-top: 0.3rem">
          <el-col :span="12" :offset="12">
            <el-button size="mini" @click="handleClearSearchGetData">清除</el-button>
            <el-button type="primary" @click="handleSearchGetData" size="mini"
              >查询</el-button
            >
          </el-col>
        </el-row>
        <el-button slot="reference" size="mini">筛选</el-button>
      </el-popover>
    </el-row>

    <el-table
      height="calc(100vh - 276px)"
      :data="orders"
      size="medium"
      style="width: 100%; margin-top: 0.2rem"
      v-cloak
      border
    >
      <el-table-column label="订单编号" width="200" fixed>
        <template slot-scope="scope">
          <el-tooltip :content="scope.row.order_num" placement="top">
            <div class="company_hover">
              <span class="count_style" style="display: inherit">
                <el-link
                  class="ellipsis-link"
                  type="primary"
                  @click="handleOrderInfo(scope.row.id, scope.row.company, scope.row.order_num)"
                  >{{ scope.row.order_num }}</el-link
                >
              </span>
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column fixed label="服务状态" width="90">
        <template slot-scope="scope">
          <div v-if="scope.row.service_status === '服务中'">
            <span class="dot" style="background-color: #88d023"></span>
            <el-link disabled>{{ scope.row.service_status }}</el-link>
          </div>
          <div v-else>
            <span class="dot" style="background-color: #ff8839"></span>
            <el-link disabled>{{ scope.row.service_status }}</el-link>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="公司名称" width="200">
        <template slot-scope="scope">
          <el-tooltip
            :content="scope.row.company ? scope.row.company : ''"
            placement="top"
          >
            <el-link
              type="primary"
              class="count-style"
              @click="fhandleCompanyInfoOpen(scope.row.company_id)"
              >{{ scope.row.company ? scope.row.company : "" }}</el-link
            >
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="单品名称" width="120">
        <template slot-scope="scope">
          <el-tooltip
            :content="scope.row.item_name ? scope.row.item_name : ''"
            placement="top"
          >
            <span class="count_style" style="display: inherit">{{
              scope.row.item_name ? scope.row.item_name : ""
            }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="变更项目" width="120">
        <template slot-scope="scope">
          <el-tooltip
            :content="handleGetProjectName(scope.row.meal_singles)"
            placement="top"
          >
            <span class="count_style" style="display: inherit">{{
              handleGetProjectName(scope.row.meal_singles)
            }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="平台" width="100">
        <template slot-scope="scope">
            <span class="hide-style">{{ scope.row.platform }}</span>
        </template>
      </el-table-column>
      <el-table-column label="顾问">
        <template slot-scope="scope">
            <span class="hide-style">{{
              scope.row.advisor ? scope.row.advisor.username : ""
            }}</span>
        </template>
      </el-table-column>
      <el-table-column label="客户名称" width="110">
        <template slot-scope="scope">
            <span class="hide-style">{{ scope.row.customer_name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="客户电话" width="170">
        <template slot-scope="scope">
            <!-- <span class="hide-style">{{ scope.row.customer_phone }}</span> -->
            <phone-com v-if="scope.row.customer_phone"
                  :comPhone="scope.row.customer_phone"
                  :vagaryPhone="scope.row.vagary_phone_custome"
                  style="display: inline-block"
                />
        </template>
      </el-table-column>
      <el-table-column label="法人名称" width="110">
        <template slot-scope="scope">
            <span class="hide-style">{{ scope.row.corporate_name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="法人电话" width="170">
        <template slot-scope="scope">
            <!-- <span class="hide-style">{{ scope.row.corporate_phone }}</span> -->
            <phone-com v-if="scope.row.corporate_phone"
                  :comPhone="scope.row.corporate_phone"
                  :vagaryPhone="scope.row.vagary_phone_corporate"
                  style="display: inline-block"
                />
        </template>
      </el-table-column>
      <el-table-column label="工商变更人员" width="110">
        <template slot-scope="scope">
          <span
            class="hide-style"
            v-if="scope.row.meal_singles.indexOf('is_industry_change') === -1"
            >/</span
          >
          <span class="hide-style" v-else>{{
            scope.row.industry_change ? scope.row.industry_change.admin.username : "未知"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="工商变更状态" width="110">
        <template slot-scope="scope">
          <span
            class="hide-style"
            v-if="scope.row.meal_singles.indexOf('is_industry_change') === -1"
            >/</span
          >
          <span class="hide-style" v-else>{{
            scope.row.industry_change
              ? scope.row.industry_change.is_finish === 1
                ? "进行中"
                : "已完成"
              : "未办理"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="税务变更人员" width="110">
        <template slot-scope="scope">
          <span
            class="hide-style"
            v-if="scope.row.meal_singles.indexOf('is_tax_change') === -1"
            >/</span
          >
          <span class="hide-style" v-else>{{
            scope.row.tax_change ? scope.row.tax_change.admin.username : "未知"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="税务变更状态" width="110">
        <template slot-scope="scope">
          <span
            class="hide-style"
            v-if="scope.row.meal_singles.indexOf('is_tax_change') === -1"
            >/</span
          >
          <span class="hide-style" v-else>{{
            scope.row.tax_change
              ? scope.row.tax_change.is_finish === 1
                ? "进行中"
                : "已完成"
              : "未办理"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="银行变更人员" width="110">
        <template slot-scope="scope">
          <span
            class="hide-style"
            v-if="scope.row.meal_singles.indexOf('is_bank_change') === -1"
            >/</span
          >
          <span class="hide-style" v-else>{{
            scope.row.bank_change ? scope.row.bank_change.admin.username : "未知"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="银行变更状态" width="110">
        <template slot-scope="scope">
          <span
            class="hide-style"
            v-if="scope.row.meal_singles.indexOf('is_bank_change') === -1"
            >/</span
          >
          <span class="hide-style" v-else>{{
            scope.row.bank_change
              ? scope.row.bank_change.is_finish === 1
                ? "进行中"
                : "已完成"
              : "未办理"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="社保变更人员" width="110">
        <template slot-scope="scope">
          <span
            class="hide-style"
            v-if="scope.row.meal_singles.indexOf('is_secuity_change') === -1"
            >/</span
          >
          <span class="hide-style" v-else>{{
            scope.row.secuity_change ? scope.row.secuity_change.admin.username : "未知"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="社保变更状态" width="110">
        <template slot-scope="scope">
          <span
            class="hide-style"
            v-if="scope.row.meal_singles.indexOf('is_secuity_change') === -1"
            >/</span
          >
          <span class="hide-style" v-else>{{
            scope.row.secuity_change
              ? scope.row.secuity_change.is_finish === 1
                ? "进行中"
                : "已完成"
              : "未办理"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="公积金变更人员" width="120">
        <template slot-scope="scope">
          <span
            class="hide-style"
            v-if="scope.row.meal_singles.indexOf('is_accum_change') === -1"
            >/</span
          >
          <span class="hide-style" v-else>{{
            scope.row.accum_change ? scope.row.accum_change.admin.username : "未知"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="公积金变更状态" width="120">
        <template slot-scope="scope">
          <span
            class="hide-style"
            v-if="scope.row.meal_singles.indexOf('is_accum_change') === -1"
            >/</span
          >
          <span class="hide-style" v-else>{{
            scope.row.accum_change
              ? scope.row.accum_change.is_finish === 1
                ? "进行中"
                : "已完成"
              : "未办理"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="140">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="办理信息" placement="top">
            <el-button
              size="mini"
              icon="el-icon-edit-outline"
              type="info"
              circle
              @click="handleEditOpen(scope.$index, scope.row)"
            ></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="电话联系记录" placement="top">
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-phone-outline"
              circle
              @click="handCallLogsOpen(scope.row)"
            ></el-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="企业微信群聊天记录"
            placement="top"
          >
            <el-button
              type="warning"
              :disabled="scope.row.wx_work_chat_com ? false : true"
              @click="
                handleWxChatOpen(scope.row.wx_work_chat_com, scope.row.company_name)
              "
              size="mini"
              icon="el-icon-s-comment"
              circle
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <div class="page-footer">
    <el-pagination
      background
      class="tr mt-10"
      layout="sizes, total, prev, pager, next, jumper"
      :hide-on-single-page="false"
      :current-page="pageOption.currentPage"
      :page-sizes="[10, 20, 30, 50, 100, 500]"
      :page-size="pageOption.pageSize"
      :total="pageOption.total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
    </div>
    <el-drawer
      title="电话联系记录"
      :visible.sync="callLogsDrawer"
      direction="rtl"
      :before-close="handleCallLogsBeforeClose"
      size="50%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <call-logs
            :company="company"
            :phone="callPhone"
            :phone1="callPhone1"
            :phone2="callPhone2"
            :phone3="callPhone3"
          ></call-logs>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer
    :title="'办理信息： ' + orderNum"
      :visible.sync="editDrawer"
      direction="rtl"
      custom-class="AIdrawer"
      :before-close="handleClearList"
      size="40%"
    >
    <div class="drawer-title" slot="title">办理信息： {{ orderNum }}</div>
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <el-col :span="24">
            <el-col>
              <el-col :span="5"><span style="line-height: 28px">公司名称：</span></el-col>
              <el-col :span="16" v-if="companyName" style="line-height: 28px">{{
                companyName
              }}</el-col>
              <el-col :span="16" v-else>
                <el-select
                  v-model="companyId"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="请输入公司字号筛选公司"
                  size="mini"
                  clearable
                  @change="handleCompanyChange"
                  :remote-method="remoteCompanyMethod"
                  :loading="loading"
                >
                  <el-option
                    v-for="company in companies"
                    :key="company.id"
                    :label="company.company_name"
                    :value="company.id"
                  >
                  </el-option>
                </el-select>
              </el-col>
            </el-col>
            <el-col :span="24">
              <span v-for="(card_item, index) in cards" :key="index">
                <el-tag style="margin: 10px 10px 0 0">{{
                  card_item === "is_industry_change"
                    ? "工商变更"
                    : card_item === "is_tax_change"
                    ? "税务变更"
                    : card_item === "is_bank_change"
                    ? "银行变更"
                    : card_item === "is_secuity_change"
                    ? "社保变更"
                    : "公积金变更"
                }}</el-tag>
              </span>
            </el-col>
          </el-col>
        </el-row>
        <el-row
          class="card-margin"
          v-for="(card_item, index) in cards"
          :key="index"
          v-if="companyName"
        >
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span v-if="card_item === 'is_industry_change'">
                <span class="header-text">工商变更</span>
                <el-popconfirm
                  title="确定工商变更完成吗？"
                  @onConfirm="handleFinishedItem(card_item)"
                >
                  <el-button
                    style="float: right"
                    slot="reference"
                    type="success"
                    size="mini"
                    :disabled="industryChange.is_finish === 2"
                    >完成</el-button
                  >
                </el-popconfirm>
              </span>
              <span v-if="card_item === 'is_tax_change'">
                <span class="header-text">税务变更</span>
                <el-popconfirm
                  title="确定税务变更完成吗？"
                  @onConfirm="handleFinishedItem(card_item)"
                >
                  <el-button
                    style="float: right"
                    slot="reference"
                    type="success"
                    size="mini"
                    :disabled="taxChange.is_finish === 2"
                    >完成</el-button
                  >
                </el-popconfirm>
              </span>
              <span v-if="card_item === 'is_bank_change'">
                <span class="header-text">银行变更</span>
                <el-popconfirm
                  title="确定银行变更完成吗？"
                  @onConfirm="handleFinishedItem(card_item)"
                >
                  <el-button
                    style="float: right"
                    slot="reference"
                    type="success"
                    size="mini"
                    :disabled="bankChange.is_finish === 2"
                    >完成</el-button
                  >
                </el-popconfirm>
              </span>
              <span v-if="card_item === 'is_secuity_change'">
                <span class="header-text">社保变更</span>
                <el-popconfirm
                  title="确定社保变更完成吗？"
                  @onConfirm="handleFinishedItem(card_item)"
                >
                  <el-button
                    style="float: right"
                    slot="reference"
                    type="success"
                    size="mini"
                    :disabled="secuityChange.is_finish === 2"
                    >完成</el-button
                  >
                </el-popconfirm>
              </span>
              <span v-if="card_item === 'is_accum_change'">
                <span class="header-text">公积金变更</span>
                <el-popconfirm
                  title="确定公积金变更完成吗？"
                  @onConfirm="handleFinishedItem(card_item)"
                >
                  <el-button
                    style="float: right"
                    slot="reference"
                    type="success"
                    size="mini"
                    :disabled="accumChange.is_finish === 2"
                    >完成</el-button
                  >
                </el-popconfirm>
              </span>
            </div>
            <el-col class="card-margin">
              <el-col :span="12">
                <el-col :span="10">&nbsp;操&nbsp;&nbsp;作&nbsp;&nbsp;人：</el-col>
                <el-col :span="14" v-if="card_item === 'is_industry_change'">{{
                  industryChange.handle ? industryChange.handle : "无"
                }}</el-col>
                <el-col :span="14" v-if="card_item === 'is_tax_change'">{{
                  taxChange.handle ? taxChange.handle : "无"
                }}</el-col>
                <el-col :span="14" v-if="card_item === 'is_bank_change'">{{
                  bankChange.handle ? bankChange.handle : "无"
                }}</el-col>
                <el-col :span="14" v-if="card_item === 'is_secuity_change'">{{
                  secuityChange.handle ? secuityChange.handle : "无"
                }}</el-col>
                <el-col :span="14" v-if="card_item === 'is_accum_change'">{{
                  accumChange.handle ? accumChange.handle : "无"
                }}</el-col>
              </el-col>
              <el-col :span="12">
                <el-col :span="8"> 操作时间：</el-col>
                <el-col :span="16" v-if="card_item === 'is_industry_change'">{{
                  industryChange.handle_at ? industryChange.handle_at : "无"
                }}</el-col>
                <el-col :span="16" v-if="card_item === 'is_tax_change'">{{
                  taxChange.handle_at ? taxChange.handle_at : "无"
                }}</el-col>
                <el-col :span="16" v-if="card_item === 'is_bank_change'">{{
                  bankChange.handle_at ? bankChange.handle_at : "无"
                }}</el-col>
                <el-col :span="16" v-if="card_item === 'is_secuity_change'">{{
                  secuityChange.handle_at ? secuityChange.handle_at : "无"
                }}</el-col>
                <el-col :span="16" v-if="card_item === 'is_accum_change'">{{
                  accumChange.handle_at ? accumChange.handle_at : "无"
                }}</el-col>
              </el-col>
            </el-col>
            <el-col>
              <el-form :model="addForm" ref="addForm" label-width="100px" size="mini">
                <el-col :span="24" class="card-margin">
                  <el-col style="margin-top: 0.2rem">
                    <el-card class="box-card">
                      <el-col :span="24" style="margin-bottom: 0.2rem">
                        <el-divider content-position="left">办理过程文件上传</el-divider>
                        <el-card shadow="hover">
                          <el-upload
                            v-if="card_item === 'is_industry_change'"
                            multiple
                            ref="upload"
                            action="#"
                            :limit="5"
                            :on-preview="handleLicensePreview"
                            :on-change="handleLicenseChange6"
                            :on-remove="handleLicenseRemove6"
                            :file-list="licenseList6"
                            accept=".jpg, .jpeg, .png, .gif, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx"
                            list-type="file"
                            :auto-upload="false"
                          >
                            <el-link
                              slot="trigger"
                              type="primary"
                              style="line-height: 28px"
                              >选择文件(最多可选择5个文件)</el-link
                            >
                            <el-button
                              type="primary"
                              size="mini"
                              style="float: right"
                              @click="submitAddUpload('addForm', card_item, 1)"
                              :disabled="industryChange.is_finish === 2"
                              >上传文件</el-button
                            >
                          </el-upload>
                          <el-upload
                            v-if="card_item === 'is_tax_change'"
                            multiple
                            ref="upload"
                            action="#"
                            :limit="5"
                            :on-preview="handleLicensePreview"
                            :on-change="handleLicenseChange7"
                            :on-remove="handleLicenseRemove7"
                            :file-list="licenseList7"
                            accept=".jpg, .jpeg, .png, .gif, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx"
                            list-type="file"
                            :auto-upload="false"
                          >
                            <el-link
                              slot="trigger"
                              type="primary"
                              style="line-height: 28px"
                              >选择文件(最多可选择5个文件)</el-link
                            >
                            <el-button
                              type="primary"
                              size="mini"
                              style="float: right"
                              @click="submitAddUpload('addForm', card_item, 1)"
                              :disabled="taxChange.is_finish === 2"
                              >上传文件</el-button
                            >
                          </el-upload>
                          <el-upload
                            v-if="card_item === 'is_bank_change'"
                            multiple
                            ref="upload"
                            action="#"
                            :limit="5"
                            :on-preview="handleLicensePreview"
                            :on-change="handleLicenseChange8"
                            :on-remove="handleLicenseRemove8"
                            :file-list="licenseList8"
                            accept=".jpg, .jpeg, .png, .gif, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx"
                            list-type="file"
                            :auto-upload="false"
                          >
                            <el-link
                              slot="trigger"
                              type="primary"
                              style="line-height: 28px"
                              >选择文件(最多可选择5个文件))</el-link
                            >
                            <el-button
                              type="primary"
                              size="mini"
                              style="float: right"
                              @click="submitAddUpload('addForm', card_item, 1)"
                              :disabled="bankChange.is_finish === 2"
                              >上传文件</el-button
                            >
                          </el-upload>
                          <el-upload
                            v-if="card_item === 'is_secuity_change'"
                            multiple
                            ref="upload"
                            action="#"
                            :limit="5"
                            :on-preview="handleLicensePreview"
                            :on-change="handleLicenseChange9"
                            :on-remove="handleLicenseRemove9"
                            :file-list="licenseList9"
                            accept=".jpg, .jpeg, .png, .gif, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx"
                            list-type="file"
                            :auto-upload="false"
                          >
                            <el-link
                              slot="trigger"
                              type="primary"
                              style="line-height: 28px"
                              >选择文件(最多可选择5个文件)</el-link
                            >
                            <el-button
                              type="primary"
                              size="mini"
                              style="float: right"
                              @click="submitAddUpload('addForm', card_item, 1)"
                              :disabled="secuityChange.is_finish === 2"
                              >上传文件</el-button
                            >
                          </el-upload>
                          <el-upload
                            v-if="card_item === 'is_accum_change'"
                            multiple
                            ref="upload"
                            action="#"
                            :limit="5"
                            :on-preview="handleLicensePreview"
                            :on-change="handleLicenseChange10"
                            :on-remove="handleLicenseRemove10"
                            :file-list="licenseList10"
                            accept=".jpg, .jpeg, .png, .gif, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx"
                            list-type="file"
                            :auto-upload="false"
                          >
                            <el-link
                              slot="trigger"
                              type="primary"
                              style="line-height: 28px"
                              >选择文件(最多可选择5个文件)</el-link
                            >
                            <el-button
                              type="primary"
                              size="mini"
                              style="float: right"
                              @click="submitAddUpload('addForm', card_item, 1)"
                              :disabled="accumChange.is_finish === 2"
                              >上传文件</el-button
                            >
                          </el-upload>
                        </el-card>
                      </el-col>
                      <el-input
                        v-if="card_item === 'is_industry_change'"
                        v-paste="handleParse6"
                        type="textarea"
                        placeholder="请点击此处，再粘贴复制的截图"
                      />
                      <el-input
                        v-if="card_item === 'is_tax_change'"
                        v-paste="handleParse7"
                        type="textarea"
                        placeholder="请点击此处，再粘贴复制的截图"
                      />
                      <el-input
                        v-if="card_item === 'is_bank_change'"
                        v-paste="handleParse8"
                        type="textarea"
                        placeholder="请点击此处，再粘贴复制的截图"
                      />
                      <el-input
                        v-if="card_item === 'is_secuity_change'"
                        v-paste="handleParse9"
                        type="textarea"
                        placeholder="请点击此处，再粘贴复制的截图"
                      />
                      <el-input
                        v-if="card_item === 'is_accum_change'"
                        v-paste="handleParse10"
                        type="textarea"
                        placeholder="请点击此处，再粘贴复制的截图"
                      />
                    </el-card>
                  </el-col>
                  <el-col style="margin-top: 0.2rem">
                    <el-card class="box-card">
                      <el-col :span="24" style="margin-bottom: 0.2rem">
                        <el-divider content-position="left">办理完成文件上传</el-divider>
                        <el-card shadow="hover">
                          <el-upload
                            v-if="card_item === 'is_industry_change'"
                            multiple
                            ref="upload"
                            action="#"
                            :limit="5"
                            :on-preview="handleLicensePreview"
                            :on-change="handleLicenseChange1"
                            :on-remove="handleLicenseRemove1"
                            :file-list="licenseList1"
                            accept=".jpg, .jpeg, .png, .gif, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx"
                            list-type="file"
                            :auto-upload="false"
                          >
                            <el-link
                              slot="trigger"
                              type="primary"
                              style="line-height: 28px"
                              >选择文件(最多可选择5个文件)</el-link
                            >
                            <el-button
                              type="primary"
                              size="mini"
                              style="float: right"
                              @click="submitAddUpload('addForm', card_item, 2)"
                              :disabled="industryChange.is_finish === 2"
                              >上传文件</el-button
                            >
                          </el-upload>
                          <el-upload
                            v-if="card_item === 'is_tax_change'"
                            multiple
                            ref="upload"
                            action="#"
                            :limit="5"
                            :on-preview="handleLicensePreview"
                            :on-change="handleLicenseChange2"
                            :on-remove="handleLicenseRemove2"
                            :file-list="licenseList2"
                            accept=".jpg, .jpeg, .png, .gif, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx"
                            list-type="file"
                            :auto-upload="false"
                          >
                            <el-link
                              slot="trigger"
                              type="primary"
                              style="line-height: 28px"
                              >选择文件(最多可选择5个文件)</el-link
                            >
                            <el-button
                              type="primary"
                              size="mini"
                              style="float: right"
                              @click="submitAddUpload('addForm', card_item, 2)"
                              :disabled="taxChange.is_finish === 2"
                              >上传文件</el-button
                            >
                          </el-upload>
                          <el-upload
                            v-if="card_item === 'is_bank_change'"
                            multiple
                            ref="upload"
                            action="#"
                            :limit="5"
                            :on-preview="handleLicensePreview"
                            :on-change="handleLicenseChange3"
                            :on-remove="handleLicenseRemove3"
                            :file-list="licenseList3"
                            accept=".jpg, .jpeg, .png, .gif, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx"
                            list-type="file"
                            :auto-upload="false"
                          >
                            <el-link
                              slot="trigger"
                              type="primary"
                              style="line-height: 28px"
                              >选择文件(最多可选择5个文件))</el-link
                            >
                            <el-button
                              type="primary"
                              size="mini"
                              style="float: right"
                              @click="submitAddUpload('addForm', card_item, 2)"
                              :disabled="bankChange.is_finish === 2"
                              >上传文件</el-button
                            >
                          </el-upload>
                          <el-upload
                            v-if="card_item === 'is_secuity_change'"
                            multiple
                            ref="upload"
                            action="#"
                            :limit="5"
                            :on-preview="handleLicensePreview"
                            :on-change="handleLicenseChange4"
                            :on-remove="handleLicenseRemove4"
                            :file-list="licenseList4"
                            accept=".jpg, .jpeg, .png, .gif, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx"
                            list-type="file"
                            :auto-upload="false"
                          >
                            <el-link
                              slot="trigger"
                              type="primary"
                              style="line-height: 28px"
                              >选择文件(最多可选择5个文件)</el-link
                            >
                            <el-button
                              type="primary"
                              size="mini"
                              style="float: right"
                              @click="submitAddUpload('addForm', card_item, 2)"
                              :disabled="secuityChange.is_finish === 2"
                              >上传文件</el-button
                            >
                          </el-upload>
                          <el-upload
                            v-if="card_item === 'is_accum_change'"
                            multiple
                            ref="upload"
                            action="#"
                            :limit="5"
                            :on-preview="handleLicensePreview"
                            :on-change="handleLicenseChange5"
                            :on-remove="handleLicenseRemove5"
                            :file-list="licenseList5"
                            accept=".jpg, .jpeg, .png, .gif, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx"
                            list-type="file"
                            :auto-upload="false"
                          >
                            <el-link
                              slot="trigger"
                              type="primary"
                              style="line-height: 28px"
                              >选择文件(最多可选择5个文件)</el-link
                            >
                            <el-button
                              type="primary"
                              size="mini"
                              style="float: right"
                              @click="submitAddUpload('addForm', card_item, 2)"
                              :disabled="accumChange.is_finish === 2"
                              >上传文件</el-button
                            >
                          </el-upload>
                        </el-card>
                      </el-col>
                      <el-input
                        v-if="card_item === 'is_industry_change'"
                        v-paste="handleParse1"
                        type="textarea"
                        placeholder="请点击此处，再粘贴复制的截图"
                      />
                      <el-input
                        v-if="card_item === 'is_tax_change'"
                        v-paste="handleParse2"
                        type="textarea"
                        placeholder="请点击此处，再粘贴复制的截图"
                      />
                      <el-input
                        v-if="card_item === 'is_bank_change'"
                        v-paste="handleParse3"
                        type="textarea"
                        placeholder="请点击此处，再粘贴复制的截图"
                      />
                      <el-input
                        v-if="card_item === 'is_secuity_change'"
                        v-paste="handleParse4"
                        type="textarea"
                        placeholder="请点击此处，再粘贴复制的截图"
                      />
                      <el-input
                        v-if="card_item === 'is_accum_change'"
                        v-paste="handleParse5"
                        type="textarea"
                        placeholder="请点击此处，再粘贴复制的截图"
                      />
                    </el-card>
                  </el-col>
                  <el-col> </el-col>
                </el-col>
              </el-form>
            </el-col>
            <el-col>
              <el-collapse
                v-model="collapseName1"
                v-if="card_item === 'is_industry_change'"
              >
                <el-collapse-item title="办理过程文件编辑" name="1">
                  <el-row style="margin-bottom: 0; padding-bottom: 0">
                    <div class="demo-image__preview">
                      <el-divider
                        content-position="left"
                        v-if="industryChange.images.length > 0"
                        >图片编辑</el-divider
                      >
                      <div
                        style="float: left"
                        v-for="(img, index) in industryChange.images"
                        :key="index"
                      >
                        <el-row style="margin: 0 0 0 0; padding: 0 0 0 0">
                          <el-image
                            style="width: 100px; height: 100px; padding: 0 5px 0 0"
                            :src="img"
                            :preview-src-list="industryChange.images"
                          >
                          </el-image>
                        </el-row>
                        <div
                          style="margin: 0 0 20px 0; padding: 0 0 0 0; text-align: center"
                        >
                          <el-popconfirm
                            title="确定要删除这张图片吗？"
                            @onConfirm="handleDeleteImage(img, card_item)"
                          >
                            <el-button
                              slot="reference"
                              size="mini"
                              type="danger"
                              plain
                              :disabled="industryChange.is_finish === 2"
                              >删除</el-button
                            >
                          </el-popconfirm>
                        </div>
                      </div>
                    </div>
                  </el-row>
                  <el-row>
                    <el-divider
                      content-position="left"
                      v-if="industryChange.files.length > 0"
                      >文件编辑</el-divider
                    >
                    <div v-for="(file, index) in industryChange.files" :key="index">
                      <el-col
                        :span="24"
                        class="text-border"
                        v-if="industryChange.files[index].type === 1"
                      >
                        <el-col :span="14" :offset="1">
                          <el-tooltip :content="file.file_name" placement="top">
                            <span class="count_style" style="display: inherit">{{
                              file.file_name
                            }}</span>
                          </el-tooltip>
                        </el-col>
                        <el-col :span="4"
                          ><el-button
                            size="mini"
                            type="success"
                            plain
                            @click="downloadFile(file.file_url)"
                            >下载文件</el-button
                          ></el-col
                        >
                        <el-col :span="4" :offset="1">
                          <el-popconfirm
                            title="确定要删除这个文件吗？"
                            @onConfirm="handleDeleteImage(file.file_url, card_item)"
                          >
                            <el-button
                              slot="reference"
                              size="mini"
                              type="danger"
                              plain
                              :disabled="industryChange.is_finish === 2"
                              >删除</el-button
                            >
                          </el-popconfirm>
                        </el-col>
                      </el-col>
                    </div>
                  </el-row>
                </el-collapse-item>
                <el-collapse-item title="办理成功文件编辑" name="2">
                  <el-row style="margin-bottom: 0; padding-bottom: 0">
                    <div class="demo-image__preview">
                      <el-divider
                        content-position="left"
                        v-if="industryChange.images2.length > 0"
                        >图片编辑</el-divider
                      >
                      <div
                        style="float: left"
                        v-for="(img, index) in industryChange.images2"
                        :key="index"
                      >
                        <el-row style="margin: 0 0 0 0; padding: 0 0 0 0">
                          <el-image
                            style="width: 100px; height: 100px; padding: 0 5px 0 0"
                            :src="img"
                            :preview-src-list="industryChange.images2"
                          >
                          </el-image>
                        </el-row>
                        <div
                          style="margin: 0 0 20px 0; padding: 0 0 0 0; text-align: center"
                        >
                          <el-popconfirm
                            title="确定要删除这张图片吗？"
                            @onConfirm="handleDeleteImage(img, card_item)"
                          >
                            <el-button
                              slot="reference"
                              size="mini"
                              type="danger"
                              plain
                              :disabled="industryChange.is_finish === 2"
                              >删除</el-button
                            >
                          </el-popconfirm>
                        </div>
                      </div>
                    </div>
                  </el-row>
                  <el-row>
                    <el-divider
                      content-position="left"
                      v-if="industryChange.files2.length > 0"
                      >文件编辑</el-divider
                    >
                    <div v-for="(file, index) in industryChange.files2" :key="index">
                      <el-col
                        :span="24"
                        class="text-border"
                        v-if="industryChange.files2[index].type === 2"
                      >
                        <el-col :span="14" :offset="1">
                          <el-tooltip :content="file.file_name" placement="top">
                            <span class="count_style" style="display: inherit">{{
                              file.file_name
                            }}</span>
                          </el-tooltip>
                        </el-col>
                        <el-col :span="4"
                          ><el-button
                            size="mini"
                            type="success"
                            plain
                            @click="downloadFile(file.file_url)"
                            >下载文件</el-button
                          ></el-col
                        >
                        <el-col :span="4" :offset="1">
                          <el-popconfirm
                            title="确定要删除这个文件吗？"
                            @onConfirm="handleDeleteImage(file.file_url, card_item)"
                          >
                            <el-button
                              slot="reference"
                              size="mini"
                              type="danger"
                              plain
                              :disabled="industryChange.is_finish === 2"
                              >删除</el-button
                            >
                          </el-popconfirm>
                        </el-col>
                      </el-col>
                    </div>
                  </el-row>
                </el-collapse-item>
              </el-collapse>
              <el-collapse v-model="collapseName2" v-if="card_item === 'is_tax_change'">
                <el-collapse-item title="办理过程文件编辑" name="1">
                  <el-row style="margin-bottom: 0; padding-bottom: 0">
                    <div class="demo-image__preview">
                      <el-divider
                        content-position="left"
                        v-if="taxChange.images.length > 0"
                        >图片编辑</el-divider
                      >
                      <div
                        style="float: left"
                        v-for="(img, index) in taxChange.images"
                        :key="index"
                      >
                        <el-row style="margin: 0 0 0 0; padding: 0 0 0 0">
                          <el-image
                            style="width: 100px; height: 100px; padding: 0 5px 0 0"
                            :src="img"
                            :preview-src-list="taxChange.images"
                          >
                          </el-image>
                        </el-row>
                        <div style="margin: 0 0 20px 0; padding: 0 0 0 0">
                          <el-popconfirm
                            title="确定要删除这张图片吗？"
                            @onConfirm="handleDeleteImage(img, card_item)"
                          >
                            <el-button
                              slot="reference"
                              size="mini"
                              type="danger"
                              plain
                              :disabled="taxChange.is_finish === 2"
                              >删除</el-button
                            >
                          </el-popconfirm>
                        </div>
                      </div>
                    </div>
                  </el-row>
                  <el-row>
                    <el-divider content-position="left" v-if="taxChange.files.length > 0"
                      >文件编辑</el-divider
                    >
                    <div v-for="(file, index) in taxChange.files" :key="index">
                      <el-col :span="24" class="text-border">
                        <el-col :span="14" :offset="1">
                          <el-tooltip :content="file.file_name" placement="top">
                            <span class="count_style" style="display: inherit">{{
                              file.file_name
                            }}</span>
                          </el-tooltip>
                        </el-col>
                        <el-col :span="4"
                          ><el-button
                            size="mini"
                            type="success"
                            plain
                            @click="downloadFile(file.file_url)"
                            >下载文件</el-button
                          ></el-col
                        >
                        <el-col :span="4" :offset="1">
                          <el-popconfirm
                            title="确定要删除这个文件吗？"
                            @onConfirm="handleDeleteImage(file.file_url, card_item)"
                          >
                            <el-button
                              slot="reference"
                              size="mini"
                              type="danger"
                              plain
                              :disabled="taxChange.is_finish === 2"
                              >删除</el-button
                            >
                          </el-popconfirm>
                        </el-col>
                      </el-col>
                    </div>
                  </el-row>
                </el-collapse-item>
                <el-collapse-item title="办理成功文件编辑" name="2">
                  <el-row style="margin-bottom: 0; padding-bottom: 0">
                    <div class="demo-image__preview">
                      <el-divider
                        content-position="left"
                        v-if="taxChange.images2.length > 0"
                        >图片编辑</el-divider
                      >
                      <div
                        style="float: left"
                        v-for="(img, index) in taxChange.images2"
                        :key="index"
                      >
                        <el-row style="margin: 0 0 0 0; padding: 0 0 0 0">
                          <el-image
                            style="width: 100px; height: 100px; padding: 0 5px 0 0"
                            :src="img"
                            :preview-src-list="taxChange.images2"
                          >
                          </el-image>
                        </el-row>
                        <div style="margin: 0 0 20px 0; padding: 0 0 0 0">
                          <el-popconfirm
                            title="确定要删除这张图片吗？"
                            @onConfirm="handleDeleteImage(img, card_item)"
                          >
                            <el-button
                              slot="reference"
                              size="mini"
                              type="danger"
                              plain
                              :disabled="taxChange.is_finish === 2"
                              >删除</el-button
                            >
                          </el-popconfirm>
                        </div>
                      </div>
                    </div>
                  </el-row>
                  <el-row>
                    <el-divider content-position="left" v-if="taxChange.files2.length > 0"
                      >文件编辑</el-divider
                    >
                    <div v-for="(file, index) in taxChange.files2" :key="index">
                      <el-col :span="24" class="text-border">
                        <el-col :span="14" :offset="1">
                          <el-tooltip :content="file.file_name" placement="top">
                            <span class="count_style" style="display: inherit">{{
                              file.file_name
                            }}</span>
                          </el-tooltip>
                        </el-col>
                        <el-col :span="4"
                          ><el-button
                            size="mini"
                            type="success"
                            plain
                            @click="downloadFile(file.file_url)"
                            >下载文件</el-button
                          ></el-col
                        >
                        <el-col :span="4" :offset="1">
                          <el-popconfirm
                            title="确定要删除这个文件吗？"
                            @onConfirm="handleDeleteImage(file.file_url, card_item)"
                          >
                            <el-button
                              slot="reference"
                              size="mini"
                              type="danger"
                              plain
                              :disabled="taxChange.is_finish === 2"
                              >删除</el-button
                            >
                          </el-popconfirm>
                        </el-col>
                      </el-col>
                    </div>
                  </el-row>
                </el-collapse-item>
              </el-collapse>
              <el-collapse v-model="collapseName3" v-if="card_item === 'is_bank_change'">
                <el-collapse-item title="办理过程文件编辑" name="1">
                  <el-row style="margin-bottom: 0; padding-bottom: 0">
                    <div class="demo-image__preview">
                      <el-divider
                        content-position="left"
                        v-if="bankChange.images.length > 0"
                        >图片编辑</el-divider
                      >
                      <div
                        style="float: left"
                        v-for="(img, index) in bankChange.images"
                        :key="index"
                      >
                        <el-row style="margin: 0 0 0 0; padding: 0 0 0 0">
                          <el-image
                            style="width: 100px; height: 100px; padding: 0 5px 0 0"
                            :src="img"
                            :preview-src-list="bankChange.images"
                          >
                          </el-image>
                        </el-row>
                        <div style="margin: 0 0 20px 0; padding: 0 0 0 0">
                          <el-popconfirm
                            title="确定要删除这张图片吗？"
                            @onConfirm="handleDeleteImage(img, card_item)"
                          >
                            <el-button
                              slot="reference"
                              size="mini"
                              type="danger"
                              plain
                              :disabled="bankChange.is_finish === 2"
                              >删除</el-button
                            >
                          </el-popconfirm>
                        </div>
                      </div>
                    </div>
                  </el-row>
                  <el-row>
                    <el-divider content-position="left" v-if="bankChange.files.length > 0"
                      >文件编辑</el-divider
                    >
                    <div v-for="(file, index) in bankChange.files" :key="index">
                      <el-col :span="24" class="text-border">
                        <el-col :span="14" :offset="1">
                          <el-tooltip :content="file.file_name" placement="top">
                            <span class="count_style" style="display: inherit">{{
                              file.file_name
                            }}</span>
                          </el-tooltip>
                        </el-col>
                        <el-col :span="4"
                          ><el-button
                            size="mini"
                            type="success"
                            plain
                            @click="downloadFile(file.file_url)"
                            >下载文件</el-button
                          ></el-col
                        >
                        <el-col :span="4" :offset="1">
                          <el-popconfirm
                            title="确定要删除这个文件吗？"
                            @onConfirm="handleDeleteImage(file.file_url, card_item)"
                          >
                            <el-button
                              slot="reference"
                              size="mini"
                              type="danger"
                              plain
                              :disabled="bankChange.is_finish === 2"
                              >删除</el-button
                            >
                          </el-popconfirm>
                        </el-col>
                      </el-col>
                    </div>
                  </el-row>
                </el-collapse-item>
                <el-collapse-item title="办理成功文件编辑" name="2">
                  <el-row style="margin-bottom: 0; padding-bottom: 0">
                    <div class="demo-image__preview">
                      <el-divider
                        content-position="left"
                        v-if="bankChange.images2.length > 0"
                        >图片编辑</el-divider
                      >
                      <div
                        style="float: left"
                        v-for="(img, index) in bankChange.images2"
                        :key="index"
                      >
                        <el-row style="margin: 0 0 0 0; padding: 0 0 0 0">
                          <el-image
                            style="width: 100px; height: 100px; padding: 0 5px 0 0"
                            :src="img"
                            :preview-src-list="bankChange.images2"
                          >
                          </el-image>
                        </el-row>
                        <div style="margin: 0 0 20px 0; padding: 0 0 0 0">
                          <el-popconfirm
                            title="确定要删除这张图片吗？"
                            @onConfirm="handleDeleteImage(img, card_item)"
                          >
                            <el-button
                              slot="reference"
                              size="mini"
                              type="danger"
                              plain
                              :disabled="bankChange.is_finish === 2"
                              >删除</el-button
                            >
                          </el-popconfirm>
                        </div>
                      </div>
                    </div>
                  </el-row>
                  <el-row>
                    <el-divider
                      content-position="left"
                      v-if="bankChange.files2.length > 0"
                      >文件编辑</el-divider
                    >
                    <div v-for="(file, index) in bankChange.files2" :key="index">
                      <el-col :span="24" class="text-border">
                        <el-col :span="14" :offset="1">
                          <el-tooltip :content="file.file_name" placement="top">
                            <span class="count_style" style="display: inherit">{{
                              file.file_name
                            }}</span>
                          </el-tooltip>
                        </el-col>
                        <el-col :span="4"
                          ><el-button
                            size="mini"
                            type="success"
                            plain
                            @click="downloadFile(file.file_url)"
                            >下载文件</el-button
                          ></el-col
                        >
                        <el-col :span="4" :offset="1">
                          <el-popconfirm
                            title="确定要删除这个文件吗？"
                            @onConfirm="handleDeleteImage(file.file_url, card_item)"
                          >
                            <el-button
                              slot="reference"
                              size="mini"
                              type="danger"
                              plain
                              :disabled="bankChange.is_finish === 2"
                              >删除</el-button
                            >
                          </el-popconfirm>
                        </el-col>
                      </el-col>
                    </div>
                  </el-row>
                </el-collapse-item>
              </el-collapse>
              <el-collapse
                v-model="collapseName4"
                v-if="card_item === 'is_secuity_change'"
              >
                <el-collapse-item title="办理过程文件编辑" name="1">
                  <el-row style="margin-bottom: 0; padding-bottom: 0">
                    <div class="demo-image__preview">
                      <el-divider
                        content-position="left"
                        v-if="secuityChange.images.length > 0"
                        >图片编辑</el-divider
                      >
                      <div
                        style="float: left"
                        v-for="(img, index) in secuityChange.images"
                        :key="index"
                      >
                        <el-row style="margin: 0 0 0 0; padding: 0 0 0 0">
                          <el-image
                            style="width: 100px; height: 100px; padding: 0 5px 0 0"
                            :src="img"
                            :preview-src-list="secuityChange.images"
                          >
                          </el-image>
                        </el-row>
                        <div style="margin: 0 0 20px 0; padding: 0 0 0 0">
                          <el-popconfirm
                            title="确定要删除这张图片吗？"
                            @onConfirm="handleDeleteImage(img, card_item)"
                          >
                            <el-button
                              slot="reference"
                              size="mini"
                              type="danger"
                              plain
                              :disabled="secuityChange.is_finish === 2"
                              >删除</el-button
                            >
                          </el-popconfirm>
                        </div>
                      </div>
                    </div>
                  </el-row>
                  <el-row>
                    <el-divider
                      content-position="left"
                      v-if="secuityChange.files.length > 0"
                      >文件编辑</el-divider
                    >
                    <div v-for="(file, index) in secuityChange.files" :key="index">
                      <el-col :span="24" class="text-border">
                        <el-col :span="14" :offset="1">
                          <el-tooltip :content="file.file_name" placement="top">
                            <span class="count_style" style="display: inherit">{{
                              file.file_name
                            }}</span>
                          </el-tooltip>
                        </el-col>
                        <el-col :span="4"
                          ><el-button
                            size="mini"
                            type="success"
                            plain
                            @click="downloadFile(file.file_url)"
                            >下载文件</el-button
                          ></el-col
                        >
                        <el-col :span="4" :offset="1">
                          <el-popconfirm
                            title="确定要删除这个文件吗？"
                            @onConfirm="handleDeleteImage(file.file_url, card_item)"
                          >
                            <el-button
                              slot="reference"
                              size="mini"
                              type="danger"
                              plain
                              :disabled="secuityChange.is_finish === 2"
                              >删除</el-button
                            >
                          </el-popconfirm>
                        </el-col>
                      </el-col>
                    </div>
                  </el-row>
                </el-collapse-item>
                <el-collapse-item title="办理成功文件编辑" name="2">
                  <el-row style="margin-bottom: 0; padding-bottom: 0">
                    <div class="demo-image__preview">
                      <el-divider
                        content-position="left"
                        v-if="secuityChange.images2.length > 0"
                        >图片编辑</el-divider
                      >
                      <div
                        style="float: left"
                        v-for="(img, index) in secuityChange.images2"
                        :key="index"
                      >
                        <el-row style="margin: 0 0 0 0; padding: 0 0 0 0">
                          <el-image
                            style="width: 100px; height: 100px; padding: 0 5px 0 0"
                            :src="img"
                            :preview-src-list="secuityChange.images2"
                          >
                          </el-image>
                        </el-row>
                        <div style="margin: 0 0 20px 0; padding: 0 0 0 0">
                          <el-popconfirm
                            title="确定要删除这张图片吗？"
                            @onConfirm="handleDeleteImage(img, card_item)"
                          >
                            <el-button
                              slot="reference"
                              size="mini"
                              type="danger"
                              plain
                              :disabled="secuityChange.is_finish === 2"
                              >删除</el-button
                            >
                          </el-popconfirm>
                        </div>
                      </div>
                    </div>
                  </el-row>
                  <el-row>
                    <el-divider
                      content-position="left"
                      v-if="secuityChange.files2.length > 0"
                      >文件编辑</el-divider
                    >
                    <div v-for="(file, index) in secuityChange.files2" :key="index">
                      <el-col :span="24" class="text-border">
                        <el-col :span="14" :offset="1">
                          <el-tooltip :content="file.file_name" placement="top">
                            <span class="count_style" style="display: inherit">{{
                              file.file_name
                            }}</span>
                          </el-tooltip>
                        </el-col>
                        <el-col :span="4"
                          ><el-button
                            size="mini"
                            type="success"
                            plain
                            @click="downloadFile(file.file_url)"
                            >下载文件</el-button
                          ></el-col
                        >
                        <el-col :span="4" :offset="1">
                          <el-popconfirm
                            title="确定要删除这个文件吗？"
                            @onConfirm="handleDeleteImage(file.file_url, card_item)"
                          >
                            <el-button
                              slot="reference"
                              size="mini"
                              type="danger"
                              plain
                              :disabled="secuityChange.is_finish === 2"
                              >删除</el-button
                            >
                          </el-popconfirm>
                        </el-col>
                      </el-col>
                    </div>
                  </el-row>
                </el-collapse-item>
              </el-collapse>
              <el-collapse v-model="collapseName5" v-if="card_item === 'is_accum_change'">
                <el-collapse-item title="办理过程文件编辑" name="1">
                  <el-row style="margin-bottom: 0; padding-bottom: 0">
                    <div class="demo-image__preview">
                      <el-divider
                        content-position="left"
                        v-if="accumChange.images.length > 0"
                        >图片编辑</el-divider
                      >
                      <div
                        style="float: left"
                        v-for="(img, index) in accumChange.images"
                        :key="index"
                      >
                        <el-row style="margin: 0 0 0 0; padding: 0 0 0 0">
                          <el-image
                            style="width: 100px; height: 100px; padding: 0 5px 0 0"
                            :src="img"
                            :preview-src-list="accumChange.images"
                          >
                          </el-image>
                        </el-row>
                        <div style="margin: 0 0 20px 0; padding: 0 0 0 0">
                          <el-popconfirm
                            title="确定要删除这张图片吗？"
                            @onConfirm="handleDeleteImage(img, card_item)"
                          >
                            <el-button
                              slot="reference"
                              size="mini"
                              type="danger"
                              plain
                              :disabled="accumChange.is_finish === 2"
                              >删除</el-button
                            >
                          </el-popconfirm>
                        </div>
                      </div>
                    </div>
                  </el-row>
                  <el-row>
                    <el-divider
                      content-position="left"
                      v-if="accumChange.files.length > 0"
                      >文件编辑</el-divider
                    >
                    <div v-for="(file, index) in accumChange.files" :key="index">
                      <el-col :span="24" class="text-border">
                        <el-col :span="14" :offset="1">
                          <el-tooltip :content="file.file_name" placement="top">
                            <span class="count_style" style="display: inherit">{{
                              file.file_name
                            }}</span>
                          </el-tooltip>
                        </el-col>
                        <el-col :span="4"
                          ><el-button
                            size="mini"
                            type="success"
                            plain
                            @click="downloadFile(file.file_url)"
                            >下载文件</el-button
                          ></el-col
                        >
                        <el-col :span="4" :offset="1">
                          <el-popconfirm
                            title="确定要删除这个文件吗？"
                            @onConfirm="handleDeleteImage(file.file_url, card_item)"
                          >
                            <el-button
                              slot="reference"
                              size="mini"
                              type="danger"
                              plain
                              :disabled="accumChange.is_finish === 2"
                              >删除</el-button
                            >
                          </el-popconfirm>
                        </el-col>
                      </el-col>
                    </div>
                  </el-row>
                </el-collapse-item>
                <el-collapse-item title="办理成功文件编辑" name="2">
                  <el-row style="margin-bottom: 0; padding-bottom: 0">
                    <div class="demo-image__preview">
                      <el-divider
                        content-position="left"
                        v-if="accumChange.images2.length > 0"
                        >图片编辑</el-divider
                      >
                      <div
                        style="float: left"
                        v-for="(img, index) in accumChange.images2"
                        :key="index"
                      >
                        <el-row style="margin: 0 0 0 0; padding: 0 0 0 0">
                          <el-image
                            style="width: 100px; height: 100px; padding: 0 5px 0 0"
                            :src="img"
                            :preview-src-list="accumChange.images2"
                          >
                          </el-image>
                        </el-row>
                        <div style="margin: 0 0 20px 0; padding: 0 0 0 0">
                          <el-popconfirm
                            title="确定要删除这张图片吗？"
                            @onConfirm="handleDeleteImage(img, card_item)"
                          >
                            <el-button
                              slot="reference"
                              size="mini"
                              type="danger"
                              plain
                              :disabled="accumChange.is_finish === 2"
                              >删除</el-button
                            >
                          </el-popconfirm>
                        </div>
                      </div>
                    </div>
                  </el-row>
                  <el-row>
                    <el-divider
                      content-position="left"
                      v-if="accumChange.files2.length > 0"
                      >文件编辑</el-divider
                    >
                    <div v-for="(file, index) in accumChange.files2" :key="index">
                      <el-col :span="24" class="text-border">
                        <el-col :span="14" :offset="1">
                          <el-tooltip :content="file.file_name" placement="top">
                            <span class="count_style" style="display: inherit">{{
                              file.file_name
                            }}</span>
                          </el-tooltip>
                        </el-col>
                        <el-col :span="4"
                          ><el-button
                            size="mini"
                            type="success"
                            plain
                            @click="downloadFile(file.file_url)"
                            >下载文件</el-button
                          ></el-col
                        >
                        <el-col :span="4" :offset="1">
                          <el-popconfirm
                            title="确定要删除这个文件吗？"
                            @onConfirm="handleDeleteImage(file.file_url, card_item)"
                          >
                            <el-button
                              slot="reference"
                              size="mini"
                              type="danger"
                              plain
                              :disabled="accumChange.is_finish === 2"
                              >删除</el-button
                            >
                          </el-popconfirm>
                        </el-col>
                      </el-col>
                    </div>
                  </el-row>
                </el-collapse-item>
              </el-collapse>
            </el-col>
          </el-card>
        </el-row>
        <el-row v-if="companyName">
          <el-popconfirm
            title="确认所有的变更都完成了吗？"
            @onConfirm="handleAllChangeOvered"
          >
            <el-button
              style="float: right"
              slot="reference"
              size="mini"
              type="success"
              :disabled="isOvered"
              >全部完成</el-button
            >
          </el-popconfirm>
        </el-row>
        <el-row style="height: 200px"></el-row>
      </div>
    </el-drawer>
    <el-drawer
    :title="'订单信息： ' + out_trade_num"
      :visible.sync="orderInfoVisible"
      direction="rtl"
      custom-class="AIdrawer"
      size="50%"
      :before-close="handleOrderInfoClose"
    >
    <div class="drawer-title" slot="title">订单信息： {{ out_trade_num }}</div>
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <order-info :orderId="orderInfoId" :checkType="serviceCheckType"></order-info>
      </div>
    </el-drawer>
    <el-drawer
      title="公司信息"
      :visible.sync="companyInfoDrawer"
      direction="rtl"
      :before-close="handleCompanyInfoBeforeClose"
      size="50%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <company-info :companyId="companyInfoId"></company-info>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer
      title="企业微信聊天记录"
      :visible.sync="wxChatDrawer"
      direction="rtl"
      :before-close="handleWxChatBeforeClose"
      size="50%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <wx-work-chat
            :chatId="wxWorkChatId"
            :chatName="wxWorkchatCompany"
          ></wx-work-chat>
        </el-row>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import WxWorkChat from "common/WxWorkChat";
import CallLogs from "common/CallLogs";
import OrderInfo from "common/OrderInfo";
import CompanyInfo from "common/CompanyInfo";
import { filterKeywordOptions } from '../../lib/cascaderUtils.js';
import PhoneCom from "common/PhoneCom";

export default {
  name: "Change",
  components: {
    CallLogs,
    CompanyInfo,
    OrderInfo,
    WxWorkChat,
    PhoneCom
  },
  data() {
    return {
      addtionData: { value: "自助下单", label: "自助下单" },
      wxChatDrawer: false,
      serviceCheckType: this.$feedBackConfig.order_service,
      wxWorkChatId: "",
      wxWorkchatCompany: "",
      editDrawer: false,
      loading: false,
      callLogsDrawer: false,
      companyInfoDrawer: false,
      searchVisible: false,
      collapseName1: [1],
      collapseName2: [1],
      collapseName3: [1],
      collapseName4: [1],
      collapseName5: [1],
      activeName: "info",
      companyInfoId: null,
      isOvered: false,
      orderId: null,
      companyId: null,
      companyName: "",
      orderNum: "",
      typeArr: [],
      cards: [],
      meals: [],
      orders: [],
      users: [],
      parks: [],
      regTypes: [],
      features: [],
      companies: [],
      orderNums: [],
      orderRegs: [],
      company: "",
      callPhone: [],
      callPhone1: [],
      callPhone2: [],
      callPhone3: [],
      licenseList1: [],
      licenseList2: [],
      licenseList3: [],
      licenseList4: [],
      licenseList5: [],
      licenseList6: [],
      licenseList7: [],
      licenseList8: [],
      licenseList9: [],
      licenseList10: [],
      formData: null,
      inputSize: "small",
      searchArr: {
        id: null,
        status: null,
        service_status: "",
        consultant: null,
        feature: null,
        actual_reg_type: null,
        operator: null,
        platform: null,
        park: null,
        company_id: null,
      },
      industry_type: null,
      tax_type: null,
      bank_type: null,
      secuity_type: null,
      accum_type: null,
      addForm: {
        index: null,
        order_id: null,
        type: "",
      },
      industryChange: {
        id: null,
        order_id: null,
        handle: "",
        handle_at: "",
        is_finish: "",
        images: [],
        files: [],
        images2: [],
        files2: [],
      },
      taxChange: {
        id: null,
        order_id: null,
        handle: "",
        handle_at: "",
        is_finish: "",
        images: [],
        files: [],
        images2: [],
        files2: [],
      },
      bankChange: {
        id: null,
        order_id: null,
        handle: "",
        handle_at: "",
        is_finish: "",
        images: [],
        files: [],
        images2: [],
        files2: [],
      },
      secuityChange: {
        id: null,
        order_id: null,
        handle: "",
        handle_at: "",
        is_finish: "",
        images: [],
        files: [],
        images2: [],
        files2: [],
      },
      accumChange: {
        id: null,
        order_id: null,
        handle: "",
        handle_at: "",
        is_finish: "",
        images: [],
        files: [],
        images2: [],
        files2: [],
      },
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        searchCurrentPage: 1, // 搜索后页码
        pageSize: 30, // 每页显示条数
      },
      orderInfoVisible: false,
      orderInfoId: null,
      searchLoading: false,
      searchCompanies: [],
      out_trade_num: ''
    };
  },
  computed: {
    searchStr: function () {
      let str = "";
      for (let key in this.searchArr) {
        str += "&" + key + "=" + this.searchArr[key];
      }

      return str;
    },
    collapse() {
      return this.$store.state.collapse;
    },
    usersConvert() {
      return [this.addtionData, ...this.users];
    },
  },
  methods: {
    handleWxChatBeforeClose(done) {
      this.wxWorkChatId = "";
      this.wxWorkchatCompany = "";
      done();
    },
    handleWxChatOpen(chat, companyName) {
      if (chat) {
        this.wxChatDrawer = true;
        setTimeout(() => {
          this.wxWorkChatId = chat.chat_id;
          this.wxWorkchatCompany = companyName;
        });
      }
    },
    handelGetOrders() {
      this.$axios
        .get("/api/industry/change?page=" + this.pageOption.currentPage + '&pageSize=' + this.pageOption.pageSize + this.searchStr)
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.orders = data.data.orders.data;
            this.orderRegs = data.data.orderRegs;
            this.meals = data.data.meals;
            this.users = data.data.users;
            this.parks = data.data.parks;
            this.regTypes = data.data.regTypes;
            this.features = data.data.features;
            this.pageOption.total = data.data.orders.total;
            for (let key in this.orders) {
              this.orders[key].item_name =
                this.orders[key].meal_singles.length > 0
                  ? this.orders[key].meal_singles[0].item_name
                  : "";
              if (this.orders[key].meal_singles.length > 0) {
                this.orders[key].meal_singles = this.getTypeArrIndex(
                  this.orders[key].meal_singles
                );
              } else {
                this.orders[key].meal_singles = [];
              }
            }
          }
        });
    },
    getTypeArrIndex(indexArr) {
      let arr = [];
      for (let key in indexArr[0]) {
        if (indexArr[0][key] === 2) {
          if (key === "item_id") {
            continue;
          }
          arr.push(key);
        }
      }
      return arr;
    },
    handleSizeChange(val) {
      this.pageOption.pageSize = val;
      this.handelGetOrders();
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val;
      this.handelGetOrders();
    },
    getOrderRegTypeName(val) {
      let obj = {};
      let name = "";
      obj = this.orderRegs.find((item) => {
        return item.order_reg_id === val;
      });
      if (obj) name = obj.order_reg_name;
      return name;
    },
    handCallLogsOpen(row) {
      this.callLogsDrawer = true;
      setTimeout(() => {
        if (row.customer_phone) this.callPhone1.push(row.customer_phone);
        if (row.corporate_phone) this.callPhone2.push(row.corporate_phone);
        if (row.company_obj) {
          this.company = row.company_obj.company_name;
          if (row.company_obj.user) this.callPhone.push(row.company_obj.user.phone);
          if (row.company_obj.docking_phone)
            this.callPhone3.push(row.company_obj.docking_phone);
        }
      });
    },
    handleCallLogsBeforeClose(done) {
      this.company = "";
      this.callPhone = [];
      this.callPhone1 = [];
      this.callPhone2 = [];
      this.callPhone3 = [];
      done();
    },
    handleEditOpen(index, row) {
      this.cards = row.meal_singles;
      this.orderId = row.id;
      this.companyName = row.company;
      this.orderNum = row.order_num;
      this.addForm.index = index;
      if (row.is_overd) {
        this.isOvered = true;
      } else {
        this.isOvered = false;
      }
      if (row.industry_change) {
        this.industryChange.id = row.industry_change.id;
        this.industryChange.type = row.industry_change.type;
        this.industryChange.handle = row.industry_change.admin.username;
        this.industryChange.handle_at = row.industry_change.handle_at;
        this.industryChange.is_finish = row.industry_change.is_finish;
        if (row.industry_change.files.length > 0) {
          for (let key in row.industry_change.files) {
            if (row.industry_change.files[key].type === 1) {
              this.industryChange.files.push(row.industry_change.files[key]);
            } else {
              this.industryChange.files2.push(row.industry_change.files[key]);
            }
          }
        }
        if (row.industry_change.images.length > 0) {
          for (let key in row.industry_change.images) {
            if (row.industry_change.images[key].type === 1) {
              this.industryChange.images.push(row.industry_change.images[key].image_url);
            } else {
              this.industryChange.images2.push(row.industry_change.images[key].image_url);
            }
          }
        }
      }
      if (row.tax_change) {
        this.taxChange.id = row.tax_change.id;
        this.taxChange.type = row.tax_change.type;
        this.taxChange.handle = row.tax_change.admin.username;
        this.taxChange.handle_at = row.tax_change.handle_at;
        this.taxChange.is_finish = row.tax_change.is_finish;
        if (row.industry_change.files.length > 0) {
          for (let key in row.tax_change.files) {
            if (row.tax_change.files[key].type === 1) {
              this.taxChange.files.push(row.tax_change.files[key]);
            } else {
              this.taxChange.files2.push(row.tax_change.files[key]);
            }
          }
        }
        if (row.tax_change.images.length > 0) {
          for (let key in row.tax_change.images) {
            if (row.tax_change.images[key].type === 1) {
              this.taxChange.images.push(row.tax_change.images[key].image_url);
            } else {
              this.taxChange.images2.push(row.tax_change.images[key].image_url);
            }
          }
        }
      }
      if (row.bank_change) {
        this.bankChange.id = row.bank_change.id;
        this.bankChange.type = row.bank_change.type;
        this.bankChange.handle = row.bank_change.admin.username;
        this.bankChange.handle_at = row.bank_change.handle_at;
        this.bankChange.is_finish = row.bank_change.is_finish;
        if (row.bank_change.files.length > 0) {
          for (let key in row.bank_change.files) {
            if (row.bank_change.files[key].type === 1) {
              this.bankChange.files.push(row.bank_change.files[key]);
            } else {
              this.bankChange.files2.push(row.bank_change.files[key]);
            }
          }
        }
        if (row.bank_change.images.length > 0) {
          for (let key in row.bank_change.images) {
            if (row.bank_change.images[key].type === 1) {
              this.bankChange.images.push(row.bank_change.images[key].image_url);
            } else {
              this.bankChange.images2.push(row.bank_change.images[key].image_url);
            }
          }
        }
      }
      if (row.secuity_change) {
        this.secuityChange.id = row.secuity_change.id;
        this.secuityChange.type = row.secuity_change.type;
        this.secuityChange.handle = row.secuity_change.admin.username;
        this.secuityChange.handle_at = row.secuity_change.handle_at;
        this.secuityChange.is_finish = row.secuity_change.is_finish;
        if (row.secuity_change.files.length > 0) {
          for (let key in row.secuity_change.files) {
            if (row.secuity_change.files[key].type === 1) {
              this.secuityChange.files.push(row.secuity_change.files[key]);
            } else {
              this.secuityChange.files2.push(row.secuity_change.files[key]);
            }
          }
        }
        if (row.secuity_change.images.length > 0) {
          for (let key in row.secuity_change.images) {
            if (row.secuity_change.images[key].type === 1) {
              this.secuityChange.images.push(row.secuity_change.images[key].image_url);
            } else {
              this.secuityChange.images2.push(row.secuity_change.images[key].image_url);
            }
          }
        }
      }
      if (row.accum_change) {
        this.accumChange.id = row.accum_change.id;
        this.accumChange.type = row.accum_change.type;
        this.accumChange.handle = row.accum_change.admin.username;
        this.accumChange.handle_at = row.accum_change.handle_at;
        this.accumChange.is_finish = row.accum_change.is_finish;
        if (row.accum_change.files.length > 0) {
          for (let key in row.accum_change.files) {
            if (row.accum_change.files[key].type === 1) {
              this.accumChange.files.push(row.accum_change.files[key]);
            } else {
              this.accumChange.files2.push(row.accum_change.files[key]);
            }
          }
        }
        if (row.accum_change.images.length > 0) {
          for (let key in row.accum_change.images) {
            if (row.accum_change.images[key].type === 1) {
              this.accumChange.images.push(row.accum_change.images[key].image_url);
            } else {
              this.accumChange.images2.push(row.accum_change.images[key].image_url);
            }
          }
        }
      }
      this.editDrawer = true;
    },
    handleLicensePreview(file) {},
    handleLicenseChange1(file, fileList) {
      this.licenseList1 = fileList;
    },
    handleLicenseChange2(file, fileList) {
      this.licenseList2 = fileList;
    },
    handleLicenseChange3(file, fileList) {
      this.licenseList3 = fileList;
    },
    handleLicenseChange4(file, fileList) {
      this.licenseList4 = fileList;
    },
    handleLicenseChange5(file, fileList) {
      this.licenseList5 = fileList;
    },
    handleLicenseChange6(file, fileList) {
      this.licenseList6 = fileList;
    },
    handleLicenseChange7(file, fileList) {
      this.licenseList7 = fileList;
    },
    handleLicenseChange8(file, fileList) {
      this.licenseList8 = fileList;
    },
    handleLicenseChange9(file, fileList) {
      this.licenseList9 = fileList;
    },
    handleLicenseChange10(file, fileList) {
      this.licenseList10 = fileList;
    },
    handleLicenseRemove1(file, fileList) {
      this.licenseList1 = fileList;
      this.formData = null;
      this.formData = new FormData();
      this.licenseList1.forEach((file) => this.formData.append("file[]", file.raw));
      for (let key in this.addForm) {
        this.formData.append(key, this.addForm[key]);
      }
    },
    handleLicenseRemove2(file, fileList) {
      this.licenseList2 = fileList;
      this.formData = null;
      this.formData = new FormData();
      this.licenseList2.forEach((file) => this.formData.append("file[]", file.raw));
      for (let key in this.addForm) {
        this.formData.append(key, this.addForm[key]);
      }
    },
    handleLicenseRemove3(file, fileList) {
      this.licenseList3 = fileList;
      this.formData = null;
      this.formData = new FormData();
      this.licenseList3.forEach((file) => this.formData.append("file[]", file.raw));
      for (let key in this.addForm) {
        this.formData.append(key, this.addForm[key]);
      }
    },
    handleLicenseRemove4(file, fileList) {
      this.licenseList4 = fileList;
      this.formData = null;
      this.formData = new FormData();
      this.licenseList4.forEach((file) => this.formData.append("file[]", file.raw));
      for (let key in this.addForm) {
        this.formData.append(key, this.addForm[key]);
      }
    },
    handleLicenseRemove5(file, fileList) {
      this.licenseList5 = fileList;
      this.formData = null;
      this.formData = new FormData();
      this.licenseList5.forEach((file) => this.formData.append("file[]", file.raw));
      for (let key in this.addForm) {
        this.formData.append(key, this.addForm[key]);
      }
    },
    handleLicenseRemove6(file, fileList) {
      this.licenseList6 = fileList;
      this.formData = null;
      this.formData = new FormData();
      this.licenseList6.forEach((file) => this.formData.append("file[]", file.raw));
      for (let key in this.addForm) {
        this.formData.append(key, this.addForm[key]);
      }
    },
    handleLicenseRemove7(file, fileList) {
      this.licenseList7 = fileList;
      this.formData = null;
      this.formData = new FormData();
      this.licenseList7.forEach((file) => this.formData.append("file[]", file.raw));
      for (let key in this.addForm) {
        this.formData.append(key, this.addForm[key]);
      }
    },
    handleLicenseRemove8(file, fileList) {
      this.licenseList8 = fileList;
      this.formData = null;
      this.formData = new FormData();
      this.licenseList8.forEach((file) => this.formData.append("file[]", file.raw));
      for (let key in this.addForm) {
        this.formData.append(key, this.addForm[key]);
      }
    },
    handleLicenseRemove9(file, fileList) {
      this.licenseList9 = fileList;
      this.formData = null;
      this.formData = new FormData();
      this.licenseList9.forEach((file) => this.formData.append("file[]", file.raw));
      for (let key in this.addForm) {
        this.formData.append(key, this.addForm[key]);
      }
    },
    handleLicenseRemove10(file, fileList) {
      this.licenseList10 = fileList;
      this.formData = null;
      this.formData = new FormData();
      this.licenseList10.forEach((file) => this.formData.append("file[]", file.raw));
      for (let key in this.addForm) {
        this.formData.append(key, this.addForm[key]);
      }
    },
    handleParse1(e) {
      let file = null;
      if (
        e.clipboardData &&
        e.clipboardData.items[0] &&
        e.clipboardData.items[0].type &&
        e.clipboardData.items[0].type.indexOf("image") > -1
      ) {
        file = e.clipboardData.items[0].getAsFile();
        let reader = new FileReader();
        reader.readAsDataURL(file);
        let that = this;
        reader.onload = function (e) {
          let fileObj = {
            name: file.name,
            percentage: 0,
            raw: file,
            size: file.size,
            status: "ready",
            url: e.target.result,
          };

          if (that.licenseList1.length < 5) {
            that.licenseList1.push(fileObj);
          } else {
            that.$message.error("最多可以上传5张");
          }
        };
      } else {
        this.$message.warning("上传的文件必须为图片");
      }
    },
    handleParse2(e) {
      let file = null;
      if (
        e.clipboardData &&
        e.clipboardData.items[0] &&
        e.clipboardData.items[0].type &&
        e.clipboardData.items[0].type.indexOf("image") > -1
      ) {
        file = e.clipboardData.items[0].getAsFile();
        let reader = new FileReader();
        reader.readAsDataURL(file);
        let that = this;
        reader.onload = function (e) {
          let fileObj = {
            name: file.name,
            percentage: 0,
            raw: file,
            size: file.size,
            status: "ready",
            url: e.target.result,
          };

          if (that.licenseList2.length < 5) {
            that.licenseList2.push(fileObj);
          } else {
            that.$message.error("最多可以上传5张");
          }
        };
      } else {
        this.$message.warning("上传的文件必须为图片");
      }
    },
    handleParse3(e) {
      let file = null;
      if (
        e.clipboardData &&
        e.clipboardData.items[0] &&
        e.clipboardData.items[0].type &&
        e.clipboardData.items[0].type.indexOf("image") > -1
      ) {
        file = e.clipboardData.items[0].getAsFile();
        let reader = new FileReader();
        reader.readAsDataURL(file);
        let that = this;
        reader.onload = function (e) {
          let fileObj = {
            name: file.name,
            percentage: 0,
            raw: file,
            size: file.size,
            status: "ready",
            url: e.target.result,
          };

          if (that.licenseList3.length < 5) {
            that.licenseList3.push(fileObj);
          } else {
            that.$message.error("最多可以上传5张");
          }
        };
      } else {
        this.$message.warning("上传的文件必须为图片");
      }
    },
    handleParse4(e) {
      let file = null;
      if (
        e.clipboardData &&
        e.clipboardData.items[0] &&
        e.clipboardData.items[0].type &&
        e.clipboardData.items[0].type.indexOf("image") > -1
      ) {
        file = e.clipboardData.items[0].getAsFile();
        let reader = new FileReader();
        reader.readAsDataURL(file);
        let that = this;
        reader.onload = function (e) {
          let fileObj = {
            name: file.name,
            percentage: 0,
            raw: file,
            size: file.size,
            status: "ready",
            url: e.target.result,
          };

          if (that.licenseList4.length < 5) {
            that.licenseList4.push(fileObj);
          } else {
            that.$message.error("最多可以上传5张");
          }
        };
      } else {
        this.$message.warning("上传的文件必须为图片");
      }
    },
    handleParse5(e) {
      let file = null;
      if (
        e.clipboardData &&
        e.clipboardData.items[0] &&
        e.clipboardData.items[0].type &&
        e.clipboardData.items[0].type.indexOf("image") > -1
      ) {
        file = e.clipboardData.items[0].getAsFile();
        let reader = new FileReader();
        reader.readAsDataURL(file);
        let that = this;
        reader.onload = function (e) {
          let fileObj = {
            name: file.name,
            percentage: 0,
            raw: file,
            size: file.size,
            status: "ready",
            url: e.target.result,
          };

          if (that.licenseList5.length < 5) {
            that.licenseList5.push(fileObj);
          } else {
            that.$message.error("最多可以上传5张");
          }
        };
      } else {
        this.$message.warning("上传的文件必须为图片");
      }
    },
    handleParse6(e) {
      let file = null;
      if (
        e.clipboardData &&
        e.clipboardData.items[0] &&
        e.clipboardData.items[0].type &&
        e.clipboardData.items[0].type.indexOf("image") > -1
      ) {
        file = e.clipboardData.items[0].getAsFile();
        let reader = new FileReader();
        reader.readAsDataURL(file);
        let that = this;
        reader.onload = function (e) {
          let fileObj = {
            name: file.name,
            percentage: 0,
            raw: file,
            size: file.size,
            status: "ready",
            url: e.target.result,
          };

          if (that.licenseList6.length < 5) {
            that.licenseList6.push(fileObj);
          } else {
            that.$message.error("最多可以上传5张");
          }
        };
      } else {
        this.$message.warning("上传的文件必须为图片");
      }
    },
    handleParse7(e) {
      let file = null;
      if (
        e.clipboardData &&
        e.clipboardData.items[0] &&
        e.clipboardData.items[0].type &&
        e.clipboardData.items[0].type.indexOf("image") > -1
      ) {
        file = e.clipboardData.items[0].getAsFile();
        let reader = new FileReader();
        reader.readAsDataURL(file);
        let that = this;
        reader.onload = function (e) {
          let fileObj = {
            name: file.name,
            percentage: 0,
            raw: file,
            size: file.size,
            status: "ready",
            url: e.target.result,
          };

          if (that.licenseList7.length < 5) {
            that.licenseList7.push(fileObj);
          } else {
            that.$message.error("最多可以上传5张");
          }
        };
      } else {
        this.$message.warning("上传的文件必须为图片");
      }
    },
    handleParse8(e) {
      let file = null;
      if (
        e.clipboardData &&
        e.clipboardData.items[0] &&
        e.clipboardData.items[0].type &&
        e.clipboardData.items[0].type.indexOf("image") > -1
      ) {
        file = e.clipboardData.items[0].getAsFile();
        let reader = new FileReader();
        reader.readAsDataURL(file);
        let that = this;
        reader.onload = function (e) {
          let fileObj = {
            name: file.name,
            percentage: 0,
            raw: file,
            size: file.size,
            status: "ready",
            url: e.target.result,
          };

          if (that.licenseList8.length < 5) {
            that.licenseList8.push(fileObj);
          } else {
            that.$message.error("最多可以上传5张");
          }
        };
      } else {
        this.$message.warning("上传的文件必须为图片");
      }
    },
    handleParse9(e) {
      let file = null;
      if (
        e.clipboardData &&
        e.clipboardData.items[0] &&
        e.clipboardData.items[0].type &&
        e.clipboardData.items[0].type.indexOf("image") > -1
      ) {
        file = e.clipboardData.items[0].getAsFile();
        let reader = new FileReader();
        reader.readAsDataURL(file);
        let that = this;
        reader.onload = function (e) {
          let fileObj = {
            name: file.name,
            percentage: 0,
            raw: file,
            size: file.size,
            status: "ready",
            url: e.target.result,
          };

          if (that.licenseList9.length < 5) {
            that.licenseList9.push(fileObj);
          } else {
            that.$message.error("最多可以上传5张");
          }
        };
      } else {
        this.$message.warning("上传的文件必须为图片");
      }
    },
    handleParse10(e) {
      let file = null;
      if (
        e.clipboardData &&
        e.clipboardData.items[0] &&
        e.clipboardData.items[0].type &&
        e.clipboardData.items[0].type.indexOf("image") > -1
      ) {
        file = e.clipboardData.items[0].getAsFile();
        let reader = new FileReader();
        reader.readAsDataURL(file);
        let that = this;
        reader.onload = function (e) {
          let fileObj = {
            name: file.name,
            percentage: 0,
            raw: file,
            size: file.size,
            status: "ready",
            url: e.target.result,
          };

          if (that.licenseList10.length < 5) {
            that.licenseList10.push(fileObj);
          } else {
            that.$message.error("最多可以上传5张");
          }
        };
      } else {
        this.$message.warning("上传的文件必须为图片");
      }
    },
    submitAddUpload(formName, cardItem, isOver) {
      this.$refs[formName][0].validate((valid) => {
        if (valid) {
          this.formData = new FormData();
          if (isOver === 2) {
            if (cardItem === "is_industry_change") {
              if (this.licenseList1.length === 0) {
                this.$message.error("请选择办理文件或图片");
                return;
              }
              this.licenseList1.forEach((file) =>
                this.formData.append("file[]", file.raw)
              );
            }
            if (cardItem === "is_tax_change") {
              if (this.licenseList2.length === 0) {
                this.$message.error("请选择办理文件或图片");
                return;
              }
              this.licenseList2.forEach((file) =>
                this.formData.append("file[]", file.raw)
              );
            }
            if (cardItem === "is_bank_change") {
              if (this.licenseList3.length === 0) {
                this.$message.error("请选择办理文件或图片");
                return;
              }
              this.licenseList3.forEach((file) =>
                this.formData.append("file[]", file.raw)
              );
            }
            if (cardItem === "is_secuity_change") {
              if (this.licenseList4.length === 0) {
                this.$message.error("请选择办理文件或图片");
                return;
              }
              this.licenseList4.forEach((file) =>
                this.formData.append("file[]", file.raw)
              );
            }
            if (cardItem === "is_accum_change") {
              if (this.licenseList5.length === 0) {
                this.$message.error("请选择办理文件或图片");
                return;
              }
              this.licenseList5.forEach((file) =>
                this.formData.append("file[]", file.raw)
              );
            }
          } else {
            if (cardItem === "is_industry_change") {
              if (this.licenseList6.length === 0) {
                this.$message.error("请选择办理文件或图片");
                return;
              }
              this.licenseList6.forEach((file) =>
                this.formData.append("file[]", file.raw)
              );
            }
            if (cardItem === "is_tax_change") {
              if (this.licenseList7.length === 0) {
                this.$message.error("请选择办理文件或图片");
                return;
              }
              this.licenseList7.forEach((file) =>
                this.formData.append("file[]", file.raw)
              );
            }
            if (cardItem === "is_bank_change") {
              if (this.licenseList8.length === 0) {
                this.$message.error("请选择办理文件或图片");
                return;
              }
              this.licenseList8.forEach((file) =>
                this.formData.append("file[]", file.raw)
              );
            }
            if (cardItem === "is_secuity_change") {
              if (this.licenseList9.length === 0) {
                this.$message.error("请选择办理文件或图片");
                return;
              }
              this.licenseList9.forEach((file) =>
                this.formData.append("file[]", file.raw)
              );
            }
            if (cardItem === "is_accum_change") {
              if (this.licenseList10.length === 0) {
                this.$message.error("请选择办理文件或图片");
                return;
              }
              this.licenseList10.forEach((file) =>
                this.formData.append("file[]", file.raw)
              );
            }
          }
          this.addForm.type = cardItem;
          this.addForm.order_id = this.orderId;
          this.addForm.is_over = isOver;
          for (let key in this.addForm) {
            this.formData.append(key, this.addForm[key]);
          }
          this.$axios.post("/api/industry/change/image", this.formData).then((res) => {
            let { data } = res;
            if (data.code === 0) {
              this.$message.success(data.msg);
              if (cardItem === "is_industry_change") {
                this.industry_type = null;
                this.orders[this.addForm.index].industry_change = data.data.change;
                this.industryChange.id = data.data.change.id;
                this.industryChange.handle = data.data.change.admin.username;
                this.industryChange.handle_at = data.data.change.handle_at;
                this.industryChange.is_finish = data.data.change.is_finish;
                if (data.data.change.images.length > 0) {
                  this.industryChange.images = [];
                  this.industryChange.images2 = [];
                  this.industryChange.files = [];
                  this.industryChange.files2 = [];
                  for (let key in data.data.change.images) {
                    if (data.data.change.images[key].type === 1) {
                      this.industryChange.images.push(
                        data.data.change.images[key].image_url
                      );
                    } else {
                      this.industryChange.images2.push(
                        data.data.change.images[key].image_url
                      );
                    }
                  }
                }
                if (data.data.change.files.length > 0) {
                  this.industryChange.files = [];
                  this.industryChange.files2 = [];
                  for (let key in data.data.change.files) {
                    if (data.data.change.files[key].type === 1) {
                      this.industryChange.files.push(data.data.change.files[key]);
                    } else {
                      this.industryChange.files2.push(data.data.change.files[key]);
                    }
                  }
                }
                this.licenseList1 = [];
                this.licenseList6 = [];
              }
              if (cardItem === "is_tax_change") {
                this.tax_type = null;
                this.orders[this.addForm.index].tax_change = data.data.change;
                this.taxChange.id = data.data.change.id;
                this.taxChange.is_finish = data.data.change.is_finish;
                this.taxChange.handle = data.data.change.admin.username;
                this.taxChange.handle_at = data.data.change.handle_at;
                if (data.data.change.images.length > 0) {
                  this.taxChange.images = [];
                  this.taxChange.images2 = [];
                  for (let key in data.data.change.images) {
                    if (data.data.change.images[key].type === 1) {
                      this.taxChange.images.push(data.data.change.images[key].image_url);
                    } else {
                      this.taxChange.images2.push(data.data.change.images[key].image_url);
                    }
                  }
                }
                if (data.data.change.files.length > 0) {
                  this.taxChange.files = [];
                  this.taxChange.files2 = [];
                  for (let key in data.data.change.files) {
                    if (data.data.change.files[key].type === 1) {
                      this.taxChange.files.push(data.data.change.files[key]);
                    } else {
                      this.taxChange.files2.push(data.data.change.files[key]);
                    }
                  }
                }
                this.licenseList2 = [];
                this.licenseList7 = [];
              }
              if (cardItem === "is_bank_change") {
                this.bank_type = null;
                this.orders[this.addForm.index].bank_change = data.data.change;
                this.bankChange.id = data.data.change.id;
                this.bankChange.is_finish = data.data.change.is_finish;
                this.bankChange.handle = data.data.change.admin.username;
                this.bankChange.handle_at = data.data.change.handle_at;
                if (data.data.change.images.length > 0) {
                  this.bankChange.images = [];
                  this.bankChange.images2 = [];
                  for (let key in data.data.change.images) {
                    if (data.data.change.images[key].type === 1) {
                      this.bankChange.images.push(data.data.change.images[key].image_url);
                    } else {
                      this.bankChange.images2.push(
                        data.data.change.images[key].image_url
                      );
                    }
                  }
                }
                if (data.data.change.files.length > 0) {
                  this.bankChange.files = [];
                  this.bankChange.files2 = [];
                  for (let key in data.data.change.files) {
                    if (data.data.change.files[key].type === 1) {
                      this.bankChange.files.push(data.data.change.files[key]);
                    } else {
                      this.bankChange.files2.push(data.data.change.files[key]);
                    }
                  }
                }
                this.licenseList3 = [];
                this.licenseList8 = [];
              }
              if (cardItem === "is_secuity_change") {
                this.secuity_type = null;
                this.orders[this.addForm.index].secuity_change = data.data.change;
                this.secuityChange.id = data.data.change.id;
                this.secuityChange.is_finish = data.data.change.is_finish;
                this.secuityChange.handle = data.data.change.admin.username;
                this.secuityChange.handle_at = data.data.change.handle_at;
                if (data.data.change.images.length > 0) {
                  this.secuityChange.images = [];
                  this.secuityChange.images2 = [];
                  for (let key in data.data.change.images) {
                    if (data.data.change.images[key].type === 1) {
                      this.secuityChange.images.push(
                        data.data.change.images[key].image_url
                      );
                    } else {
                      this.secuityChange.images2.push(
                        data.data.change.images[key].image_url
                      );
                    }
                  }
                }
                if (data.data.change.files.length > 0) {
                  this.secuityChange.files = [];
                  this.secuityChange.files2 = [];
                  for (let key in data.data.change.files) {
                    if (data.data.change.files[key].type === 1) {
                      this.secuityChange.files.push(data.data.change.files[key]);
                    } else {
                      this.secuityChange.files2.push(data.data.change.files[key]);
                    }
                  }
                }
                this.licenseList4 = [];
                this.licenseList9 = [];
              }
              if (cardItem === "is_accum_change") {
                this.accum_type = null;
                this.orders[this.addForm.index].accum_change = data.data.change;
                this.accumChange.id = data.data.change.id;
                this.accumChange.is_finish = data.data.change.is_finish;
                this.accumChange.handle = data.data.change.admin.username;
                this.accumChange.handle_at = data.data.change.handle_at;
                if (data.data.change.images.length > 0) {
                  this.accumChange.images = [];
                  this.accumChange.images2 = [];
                  for (let key in data.data.change.images) {
                    if (data.data.change.images[key].type === 1) {
                      this.accumChange.images.push(
                        data.data.change.images[key].image_url
                      );
                    } else {
                      this.accumChange.images2.push(
                        data.data.change.images[key].image_url
                      );
                    }
                  }
                }
                if (data.data.change.files.length > 0) {
                  this.accumChange.files = [];
                  this.accumChange.files2 = [];
                  for (let key in data.data.change.files) {
                    if (data.data.change.files[key].type === 1) {
                      this.accumChange.files.push(data.data.change.files[key]);
                    } else {
                      this.accumChange.files2.push(data.data.change.files[key]);
                    }
                  }
                }
                this.licenseList5 = [];
                this.licenseList10 = [];
              }
              this.formData = null;
              this.$refs["addForm"][0].resetFields();
            } else {
              this.$message.error(data.msg);
            }
          });
        }
      });
    },
    handleDeleteImage(img, cardItem) {
      let recordId = null;
      if (cardItem === "is_industry_change") {
        recordId = this.industryChange.id;
      }
      if (cardItem === "is_tax_change") {
        recordId = this.taxChange.id;
      }
      if (cardItem === "is_bank_change") {
        recordId = this.bankChange.id;
      }
      if (cardItem === "is_secuity_change") {
        recordId = this.secuityChange.id;
      }
      if (cardItem === "is_accum_change") {
        recordId = this.accumChange.id;
      }
      this.$axios
        .post("/api/industry/change/delete", { path: img, record_id: recordId })
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            if (cardItem === "is_industry_change") {
              this.orders[this.addForm.index].industry_change = data.data.change;
              this.industryChange.handle = data.data.change.admin.username;
              this.industryChange.handle_at = data.data.change.handle_at;
              if (data.data.change.files.length > 0) {
                this.industryChange.files = [];
                this.industryChange.files2 = [];
                for (let key in data.data.change.files) {
                  if (data.data.change.files[key].type === 1) {
                    this.industryChange.files.push(data.data.change.files[key]);
                  } else {
                    this.industryChange.files2.push(data.data.change.files[key]);
                  }
                }
              }
              if (data.data.change.images.length > 0) {
                this.industryChange.images = [];
                this.industryChange.images2 = [];
                for (let key in data.data.change.images) {
                  if (data.data.change.images[key].type === 1) {
                    this.industryChange.images.push(
                      data.data.change.images[key].image_url
                    );
                  } else {
                    this.industryChange.images2.push(
                      data.data.change.images[key].image_url
                    );
                  }
                }
              }
            }
            if (cardItem === "is_tax_change") {
              this.orders[this.addForm.index].tax_change = data.data.change;
              this.taxChange.handle = data.data.change.admin.username;
              this.taxChange.handle_at = data.data.change.handle_at;
              if (data.data.change.files.length > 0) {
                this.taxChange.files = [];
                this.taxChange.files2 = [];
                for (let key in data.data.change.files) {
                  if (data.data.change.files[key].type === 1) {
                    this.taxChange.files.push(data.data.change.files[key]);
                  } else {
                    this.taxChange.files2.push(data.data.change.files[key]);
                  }
                }
              }
              if (data.data.change.images.length > 0) {
                this.taxChange.images = [];
                this.taxChange.images2 = [];
                for (let key in data.data.change.images) {
                  if (data.data.change.images[key].type === 1) {
                    this.taxChange.images.push(data.data.change.images[key].image_url);
                  } else {
                    this.taxChange.images2.push(data.data.change.images[key].image_url);
                  }
                }
              }
            }
            if (cardItem === "is_bank_change") {
              this.orders[this.addForm.index].bank_change = data.data.change;
              this.bankChange.handle = data.data.change.admin.username;
              this.bankChange.handle_at = data.data.change.handle_at;
              if (data.data.change.files.length > 0) {
                this.bankChange.files = [];
                this.bankChange.files2 = [];
                for (let key in data.data.change.files) {
                  if (data.data.change.files[key].type === 1) {
                    this.bankChange.files.push(data.data.change.files[key]);
                  } else {
                    this.bankChange.files2.push(data.data.change.files[key]);
                  }
                }
              }
              if (data.data.change.images.length > 0) {
                this.bankChange.images = [];
                this.bankChange.images2 = [];
                for (let key in data.data.change.images) {
                  if (data.data.change.images[key].type === 1) {
                    this.bankChange.images.push(data.data.change.images[key].image_url);
                  } else {
                    this.bankChange.images2.push(data.data.change.images[key].image_url);
                  }
                }
              }
            }
            if (cardItem === "is_secuity_change") {
              this.orders[this.addForm.index].secuity_change = data.data.change;
              this.secuityChange.handle = data.data.change.admin.username;
              this.secuityChange.handle_at = data.data.change.handle_at;
              if (data.data.change.files.length > 0) {
                this.secuityChange.files = [];
                this.secuityChange.files2 = [];
                for (let key in data.data.change.files) {
                  if (data.data.change.files[key].type === 1) {
                    this.secuityChange.files.push(data.data.change.files[key]);
                  } else {
                    this.secuityChange.files2.push(data.data.change.files[key]);
                  }
                }
              }
              if (data.data.change.images.length > 0) {
                this.secuityChange.images = [];
                this.secuityChange.images2 = [];
                for (let key in data.data.change.images) {
                  if (data.data.change.images[key].type === 1) {
                    this.secuityChange.images.push(
                      data.data.change.images[key].image_url
                    );
                  } else {
                    this.secuityChange.images2.push(
                      data.data.change.images[key].image_url
                    );
                  }
                }
              }
            }
            if (cardItem === "is_accum_change") {
              this.orders[this.addForm.index].accum_change = data.data.change;
              this.accumChange.handle = data.data.change.admin.username;
              this.accumChange.handle_at = data.data.change.handle_at;
              if (data.data.change.files.length > 0) {
                this.accumChange.files = [];
                this.accumChange.files2 = [];
                for (let key in data.data.change.files) {
                  if (data.data.change.files[key].type === 1) {
                    this.accumChange.files.push(data.data.change.files[key]);
                  } else {
                    this.accumChange.files2.push(data.data.change.files[key]);
                  }
                }
              }
              if (data.data.change.images.length > 0) {
                this.accumChange.images = [];
                this.accumChange.images2 = [];
                for (let key in data.data.change.images) {
                  if (data.data.change.images[key].type === 1) {
                    this.accumChange.images.push(data.data.change.images[key].image_url);
                  } else {
                    this.accumChange.images2.push(data.data.change.images[key].image_url);
                  }
                }
              }
            }
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    handleFinishedItem(cardItem) {
      let recordId = null;
      if (cardItem === "is_industry_change") {
        recordId = this.industryChange.id;
      }
      if (cardItem === "is_tax_change") {
        recordId = this.taxChange.id;
      }
      if (cardItem === "is_bank_change") {
        recordId = this.bankChange.id;
      }
      if (cardItem === "is_secuity_change") {
        recordId = this.secuityChange.id;
      }
      if (cardItem === "is_accum_change") {
        recordId = this.accumChange.id;
      }
      if (!recordId) {
        this.$message.error("请上传变更所需的文件后再确认完成！");
        return false;
      }
      this.$axios.post("/api/industry/change/finish/" + recordId).then((res) => {
        let { data } = res;
        if (data.code === 0) {
          if (cardItem === "is_industry_change") {
            this.orders[this.addForm.index].industry_change = data.data.change;
            this.industryChange.handle = data.data.change.admin.username;
            this.industryChange.handle_at = data.data.change.handle_at;
            this.industryChange.is_finish = data.data.change.is_finish;
          }
          if (cardItem === "is_tax_change") {
            this.orders[this.addForm.index].tax_change = data.data.change;
            this.taxChange.handle = data.data.change.admin.username;
            this.taxChange.handle_at = data.data.change.handle_at;
            this.taxChange.is_finish = data.data.change.is_finish;
          }
          if (cardItem === "is_bank_change") {
            this.orders[this.addForm.index].bank_change = data.data.change;
            this.bankChange.handle = data.data.change.admin.username;
            this.bankChange.handle_at = data.data.change.handle_at;
            this.bankChange.is_finish = data.data.change.is_finish;
          }
          if (cardItem === "is_secuity_change") {
            this.orders[this.addForm.index].secuity_change = data.data.change;
            this.secuityChange.handle = data.data.change.admin.username;
            this.secuityChange.handle_at = data.data.change.handle_at;
            this.secuityChange.is_finish = data.data.change.is_finish;
          }
          if (cardItem === "is_accum_change") {
            this.orders[this.addForm.index].accum_change = data.data.change;
            this.accumChange.handle = data.data.change.admin.username;
            this.accumChange.handle_at = data.data.change.handle_at;
            this.accumChange.is_finish = data.data.change.is_finish;
          }
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    downloadFile(url) {
      window.open(url);
    },
    handleAllChangeOvered() {
      this.$axios.post("/api/industry/change/overed/" + this.orderId).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.isOvered = true;
          this.orders[this.addForm.index].is_overd = data.data.change;
          this.$message.success(data.msg);
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    handleClearList() {
      this.editDrawer = false;
      this.licenseList1 = [];
      this.licenseList2 = [];
      this.licenseList3 = [];
      this.licenseList4 = [];
      this.licenseList5 = [];
      this.licenseList6 = [];
      this.licenseList7 = [];
      this.licenseList8 = [];
      this.licenseList9 = [];
      this.licenseList10 = [];
      this.industryChange.id = null;
      this.industryChange.type = "";
      this.industryChange.handle = "";
      this.industryChange.handle_at = "";
      this.industryChange.is_finish = "";
      this.industryChange.files = [];
      this.industryChange.files2 = [];
      this.industryChange.images = [];
      this.industryChange.images2 = [];
      this.taxChange.id = null;
      this.taxChange.type = "";
      this.taxChange.handle = "";
      this.taxChange.handle_at = "";
      this.taxChange.is_finish = "";
      this.taxChange.files = [];
      this.taxChange.files2 = [];
      this.taxChange.images = [];
      this.taxChange.images2 = [];
      this.bankChange.id = null;
      this.bankChange.type = "";
      this.bankChange.handle = "";
      this.bankChange.handle_at = "";
      this.bankChange.is_finish = "";
      this.bankChange.files = [];
      this.bankChange.files2 = [];
      this.bankChange.images = [];
      this.bankChange.images2 = [];
      this.secuityChange.id = null;
      this.secuityChange.type = "";
      this.secuityChange.handle = "";
      this.secuityChange.handle_at = "";
      this.secuityChange.is_finish = "";
      this.secuityChange.files = [];
      this.secuityChange.files2 = [];
      this.secuityChange.images = [];
      this.secuityChange.images2 = [];
      this.accumChange.id = null;
      this.accumChange.type = "";
      this.accumChange.handle = "";
      this.accumChange.handle_at = "";
      this.accumChange.is_finish = "";
      this.accumChange.files = [];
      this.accumChange.files2 = [];
      this.accumChange.images = [];
      this.accumChange.images2 = [];
      this.addForm.index = null;
      this.addForm.order_id = null;
      this.addForm.type = "";
      this.industry_type = null;
      this.tax_type = null;
      this.bank_type = null;
      this.secuity_type = null;
      this.accum_type = null;
      this.companyId = null;
      this.companyName = "";
      this.isOvered = false;
      this.formData = null;
    },
    handleOrderChange() {
      this.pageOption.currentPage = 1;
      this.handelGetOrders();
    },
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.searchOrders(query);
        }, 200);
      } else {
        this.orderNums = [];
      }
    },
    searchOrders(query) {
      this.$axios.get("/api/admin/searchOrders?num=" + query).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.orderNums = data.data.orderNum;
        }
      });
    },
    remoteCompanyMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.searchCompanys(query);
        }, 200);
      } else {
        this.companies = [];
      }
    },
    searchCompanys(query) {
      this.$axios.get("/api/admin/searchCompany?name=" + query).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.companies = data.data.companies;
        }
      });
    },
    handleCompanyChange() {
      this.$axios
        .post("/api/industry/change/save_company/" + this.orderId, {
          cid: this.companyId,
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.companyName = data.data.cname;
            this.orders[this.addForm.index].company_id = this.companyId;
            this.orders[this.addForm.index].company = data.data.cname;
            this.$message.success(data.msg);
          }
        });
    },
    handleGetProjectName(cards) {
      let arr = {
        is_industry_change: "工商变更",
        is_tax_change: "税务变更",
        is_bank_change: "银行变更",
        is_secuity_change: "社保变更",
        is_accum_change: "公积金变更",
      };
      let typeStr = "";
      for (var i = 0; i < cards.length; i++) {
        if (i === cards.length - 1) {
          typeStr += arr[cards[i]];
        } else {
          typeStr += arr[cards[i]] + " , ";
        }
      }
      return typeStr;
    },
    handleOrderInfo(orderId, companyName, order_num) {
      this.orderInfoVisible = true;
      setTimeout(() => {
        this.orderInfoId = orderId;
        this.out_trade_num = order_num;
      });
    },
    fhandleCompanyInfoOpen(cid) {
      this.companyInfoDrawer = true;
      setTimeout(() => {
        this.companyInfoId = cid;
      });
    },
    handleCompanyInfoBeforeClose(done) {
      this.companyInfoId = null;
      done();
    },
    handleOrderInfoClose(done) {
      this.orderInfoId = null;
      done();
    },
    handleClearSearchGetData() {
      this.searchArr.service_status = "";
      this.searchArr.consultant = null;
      this.searchArr.feature = null;
      this.searchArr.actual_reg_type = null;
      this.searchArr.operator = null;
      this.searchArr.platform = null;
      this.searchArr.park = null;
      this.searchArr.company_id = null;
      this.pageOption.currentPage = 1;
      this.searchVisible = false;
      this.handelGetOrders();
    },
    handleSearchGetData() {
      this.searchVisible = false;
      this.pageOption.currentPage = 1;
      this.handelGetOrders();
    },
    searchRemoteCompanyMethod(query) {
      if (query !== "") {
        this.searchLoading = true;
        setTimeout(() => {
          this.searchLoading = false;
          this.searchArrItemCompanys(query);
        }, 200);
      } else {
        this.searchCompanies = [];
      }
    },
    searchArrItemCompanys(query) {
      this.$axios.get("/api/admin/searchCompany?name=" + query).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.searchCompanies = data.data.companies;
        }
      });
    },
    handleSearchCompanyChange(val) {
      this.pageOption.currentPage = 1;
      this.handelGetOrders();
    },
    filterOptions(node, keyword) {
  return filterKeywordOptions(node, keyword);
}
  },
  mounted() {
    this.handelGetOrders();
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
@import '~styles/vertical.styl'
[v-cloak]
  display: none;
.text-border
 border: 1px solid #dcdfe6
 border-radius: 5px
 line-height: 45px
 margin-bottom: .1rem
.border-line
  border: solid 1px red
.header-text
  font-size: 16px
  color: #4d84fe
.card-margin
  margin-bottom: .4rem
.count_style
  display: inherit
  overflow: hidden
  text-overflow: ellipsiss
  white-space: nowrap
.check-succ
  color: #67C23A
.setBadge >>> .el-badge__content.is-fixed
  top: .22rem
  right: .06rem
.el-drawer__wrapper >>> .el-drawer
  overflow-y: auto
.change >>> .el-drawer__header
  font-size: .36rem
  font-weight: 400
  color: #4D84FE
.change >>> .el-table__header th
  color: #333333
.change >>> .el-timeline-item__node--normal
  left: 0
  background-color: #ECF4FF
.el-cascader
  width: 100%
.change
  marginLeft()
  .count-style
    display: inherit
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap
.clearfix:before,
.clearfix:after
  display: table
  content: ""
.clearfix:after
  clear: both
.search-row .el-col
  margin-bottom: .2rem
.count
  padding-left: .2rem
  line-height: .56rem
.el-collapse
  border-bottom 0
  border-top 0
.el-collapse >>> .el-collapse-item__header
  color: #4C87FC
  font-weight bold
.el-collapse >>> .el-collapse-item__arrow
  color: #4C87FC
.tr
  text-align: right
.dot
  display: inline-block
  width: 0.1rem
  height: 0.1rem
  border-radius: 50%
  margin-right: 0.1rem
  top: 0
  left: -.2rem
  bottom: 0
  margin: auto
.mt-50
  margin-top: 1rem
.mt-10
  margin-top: .2rem
.mb-10
  margin-bottom: .2rem
.m-tabs-content
  padding: 0 .2rem 0 .4rem
  .tabs-title
    color: #5789F4
  .m-label
    line-height: .64rem
  .el-row
    margin-bottom: .4rem
  .el-date-editor.el-input, .el-date-editor.el-input__inner
    width: 100%
.el-date-editor
  width: 100% !important
.ellipsis-link
  display: inline-block
  max-width: 100%
  overflow: hidden
  text-overflow: ellipsis
  white-space: nowrap
.page-footer
  position: fixed
  bottom: 0
  left: 0
  height: 80px
  background: #fff
  width: 100%
  z-index: 2
.pagination-style
  padding-top: 15px
  text-align: right
.AIdrawer .drawer-title
  background-color: #ecf5ff
  padding: 10px
  color: #409EFF
</style>



// WEBPACK FOOTER //
// src/pages/customer/Change.vue